// import "./app-base";
// import "./org-search/search-app";
// import "./org-search/collections";
// import "./org-search/model";
// import "./org-search/views";
// import "./order/order-model";
// import "./order/models";
// import "./order/collections";
// import "./order/views";
// import "./order/order-app";
// import "./booking/models";
// import "./booking/collections";
// import "./booking/views";
// import "./booking/booking-app";
// import "./booking/repeat-order";
// import "./booking1/rent-roaster";
// import "./reviews";
window.addEventListener("testEvent", function (event) {
	console.log("eventt", event.detail.addr)
	console.log(document.querySelector("#delivery-wrapper .delivery-card.external .delivery-card__additional_additional")
		.innerHTML = `${event.detail.addr}`)
})
window.KApp = {
	Views: {},
	Models: {},
	Collections: {},
	Options: {
		basketTypes: ['coffee', 'roasters', 'pack'],
		indicators: '.header-indicators',
		mobileBreakpoint: 992
	},
	Helpers: {
		template: function (id) {
			return _.template($('#' + id)
				.html());
		},
		moneyFormat: wNumb({
			prefix: '$',
			thousand: '',
			decimals: 2,
		}),
		natMoneyFormat: wNumb({
			thousand: '',
			decimals: 2,
			suffix: ' ₽'
		}),
		errors: {
			100: 'Укажите дату, на которую необходимо зарезервировать ростер',
			101: 'Пустой заказ. Выберите хотя бы один товар.',
			201: 'Выберите вариант доставки',
			202: 'Для выбранного варианта доставки необходимо заполнить все обязательные поля'
		},
		sortProductsList: function (list) {
			return _.sortBy(list, function (model) {
				var result
				if (model.type === 'coffee') {
					result = (model.transit === '')
				} else {
					result = true
				}
				return result
			});
		},
		decompress: function (compressed) {
			//var decompressed = LZString.decompressFromEncodedURIComponent(compressed);
			var decompressed = JSON.parse(compressed);
			return decompressed;
		},
		isDesktop: function () {
			return parseInt(window.innerWidth) >= KApp.Options.mobileBreakpoint;
		},
		isMobile: function () {
			return parseInt(window.innerWidth) < KApp.Options.mobileBreakpoint;
		},
		/*TODO: убрать это*/
		orderResultsAffix: function () {
			var wrapper = document.querySelector('.order-results'),
				$wrapper = $(wrapper);
			if (wrapper !== undefined) {
				var wHeader = wrapper.querySelector('.order-results-header'),
					wBody = wrapper.querySelector('.order-results-body'),
					wFooter = wrapper.querySelector('.order-results-footer'),
					winHeight = document.body.clientHeight,
					headerHeight = document.querySelector('.header')
					.clientHeight + 16,
					wrapHeight = winHeight - headerHeight - 10;
				wrapper.style.height = wrapHeight + 'px';
				wrapper.style.top = headerHeight + 'px';
				wrapper.style.width = wrapper.clientWidth + 'px';
				wrapper.parentNode.style.minHeight = wrapHeight + 'px';
			}
			setTimeout(function () {
				$wrapper.affix({ //приклеиваем, чтобы корзина была на виду
					offset: {
						top: 45,
						bottom: function () {
							var bottom = document.getElementById('page-footer')
								.clientHeight;
							return (this.bottom = bottom);
						}
					}
				});
			}, 100);
			var maxH = wrapHeight - wHeader.clientHeight - wFooter.clientHeight;
			//задаем максимальную высоту области с товарами и инициализируем прокрутку списка товаров
			$(wBody)
				.css({
					'max-height': maxH,
					'height': maxH
				})
				.jScrollPane({
					width: '100%',
					height: maxH,
					autoReinitialise: true
				});
		},
		/*Установка размеров для сайдбара*/
		makeSidebar: function () {
			var sb = document.getElementById('personal-sidebar');
			if (typeof sb === "undefined" || KApp.Helpers.isMobile()) return false;
			var styles = getComputedStyle(sb);
		},
		showBox: function (box, speed) {
			var duration = speed || 1;
			if (box) {
				if (!box.classList.contains('show')) {
					box.classList.add('show');
					anime({
						targets: box,
						duration: duration,
						opacity: [0, 1],
						easing: 'linear'
					});
				}
			}
		},
		hideBox: function (box, speed) {
			var duration = speed || 1;
			if (box) {
				if (box.classList.contains('show')) {
					anime({
						targets: box,
						duration: duration,
						opacity: [1, 0],
						easing: 'linear',
						complete: function () {
							box.classList.remove('show');
						}
					});
				}
			}
		},
		/*Смена шага заказа*/
		changeStep: function (model, step) {
			var step = parseInt(step),
				prevStep = model._previousAttributes.currentStep;
			var prevStepNode = document.getElementById('step-' + prevStep),
				currStepNode = document.getElementById('step-' + step);
			//  prevStepNode.classList.add('d-none');
			//  currStepNode.classList.remove('d-none');
			var currStepAnime = anime({
				targets: currStepNode,
				opacity: [0, 1],
				duration: 250,
				easing: 'easeOutQuint',
				autoplay: false
			});
			anime({
				targets: prevStepNode,
				opacity: [1, 0],
				easing: 'easeInQuint',
				duration: 150,
				complete: function () {
					prevStepNode.classList.add('d-none');
					currStepNode.classList.remove('d-none');
					currStepAnime.play();
				}
			})
		},
		showNotify: function (data, duration, targetId) {
			if (typeof targetId === 'undefined') return false;
			var notifyModel = new KApp.Models.Alert(data);
			var notify = new KApp.Views.Alert({
				el: targetId,
				model: notifyModel,
				duration: duration
			});
		},
		/**Склонение числительны.
		 * @param {number} number - числительное
		 * @param {array} titles - словоформы
		 * @return {string} title - возвращает требуемую словоформу
		 * */
		numerals: function (number, titles) {
			var cases = [2, 0, 1, 1, 1, 2];
			return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
		},
	}
};
$(function () {});
window.OrgSearch = {
	Models: {},
	Views: {},
	Collections: {}
}
/*Коллекция для результатов поиска по организациям*/
OrgSearch.Collections.SearchResults = Backbone.Collection.extend({
	search: function (query) {
		this.fetch({
			url: ORG_SEARCH_URL,
			method: "POST",
			data: query,
			success: function (col, response) {
				if (response.success) {
					col.reset(response.data);
				}
			}
		});
	}
});
/*Модель поиска по организациям*/
OrgSearch.Models.SearchModel = Backbone.Model.extend({
	defaults: {
		name: '',
		placeholder: 'Введите название',
		selectedName: '',
		selectedId: '',
		results: ''
	},
	initialize: function () {
		var results = new OrgSearch.Collections.SearchResults({
			url: ORG_SEARCH_URL
		});
		results.on('reset', this.resultsHandler, this);
		results.on('selected', this.selectResult, this);
		this.set('results', results);
		var throttleSearch = _.throttle(this.sendQuery, 500, {
			leading: false
		});
		this.on('change:name', throttleSearch, this);
	},
	sendQuery: function () {
		var results = this.get('results');
		var name = this.get('name');
		if (name === '' || name.length < 3) {
			results.reset();
			return false;
		}
		results.search({
			name: name
		});
	},
	resultsHandler: function () {
		this.trigger('resultsUpdated');
		var results = this.get('results');
		results.trigger('resultsUpdated');
	},
	/*Выбор плательщика*/
	selectResult: function (data) {
		this.set('selectedId', data.ID, {
			silent: true
		});
		this.set('selectedName', data.NAME, {
			silent: true
		});
		this.trigger('resultSelected', data);
		var results = this.get('results');
		results.reset();
	},
	clearResult: function () {
		this.set('selectedId', '', {
			silent: true
		});
		this.set('selectedName', '', {
			silent: true
		});
		this.trigger('clearSelection');
	}
});
/*Поиск по организациям*/
OrgSearch.Views.SearchFieldView = Backbone.View.extend({
	el: '#org-search-input',
	initialize: function () {
		this.render();
		var resultsList = new OrgSearch.Views.SearchResultsView({
			collection: this.model.get('results')
		});
		this.model.on('resultSelected', this.render, this); //когда пользователь выбрал результат поиска
	},
	events: {
		'input .query': 'updateQuery',
		'click .clear-select': 'clearSelection'
	},
	render: function () {
		var tpl = KApp.Helpers.template('tpl-org-search-form');
		this.el.innerHTML = tpl(this.model.attributes);
	},
	updateQuery: function (e) {
		this.model.set('name', e.target.value);
	},
	/*Удаляем выбранный образец*/
	clearSelection: function () {
		this.model.clearResult();
		this.render();
	}
});
OrgSearch.Views.SearchResultsView = Backbone.View.extend({
	el: '#org-search-results',
	initialize: function () {
		this.render();
		this.collection.on('resultsUpdated', this.render, this);
		this.initOuterClick();
	},
	render: function () {
		this.undelegateEvents();
		this.el.innerHTML = '';
		if (this.collection.length) {
			this.el.classList.remove('empty');
			this.collection.each(this.renderOne, this);
		} else this.el.classList.add('empty');
	},
	renderOne: function (model) {
		var item = new OrgSearch.Views.SearchResultItem({
			model: model
		});
		this.el.appendChild(item.el);
	},
	initOuterClick: function () {
		var collection = this.collection;
		$(document)
			.on('click', function (e) {
				if (!$(e.target)
					.closest(".org-search__form")
					.length && !$(e.target)
					.closest('.org-search__results')
					.length) {
					collection.reset();
				}
			});
	}
});
OrgSearch.Views.SearchResultItem = Backbone.View.extend({
	tagName: 'div',
	className: 'search-result-item-wrapper',
	initialize: function () {
		this.render();
	},
	events: {
		'click .search-result-item': 'clickHandler'
	},
	render: function () {
		var model = this.model;
		if (model.get('ID') && model.get('NAME')) {
			var tpl = _.template('<div class="search-result-item" id="<%=ID%>"><%=NAME%></div>');
			this.el.innerHTML = tpl(this.model.attributes);
		}
	},
	clickHandler: function () {
		this.model.collection.trigger('selected', this.model.attributes);
	}
});
$(function () {
	/*Модель товара в каталоге*/
	KApp.Models.ProductModel = Backbone.Model.extend({
		defaults: {
			id: 1,
			pid: '',
			title: '',
			lotid: '',
			url: '',
			description: '',
			pack: '',
			store: '0',
			ico: '',
			amount: 10,
			stack: 0,
			unit: 'кг',
			quantity: 0,
			cost: 10.82,
			oldCost: '',
			currency: '$',
			type: 'coffee',
			needShowMore: false, //для использования в мобильном отображении, чтобы корректно рендерился блок "Подробней о сорте"
			langDefaults: {
				btnText: 'В корзину',
				btnClass: 'btn-gray'
			},
			filtered: false, //поле для фильтрации (используется при заказе кофе и образцов)
			storageCost: '', //цена с учетом хранения (используется при заказе кофе от фермера)
			canAddToCart: true, //можно ли добавлять в корзину (если false, то блокируется кнопка + и инпут)
			transit: false, //транзитный кофе (не выводится лот, нельзя купить, ссылка на раздел "Транзит")
			transitData: null //дата прибытия транзитного кофе
		},
		initialize: function () {
			this.on('change:quantity', this.checkStorage, this);
		},
		setQuan: function (q) {
			if (this.checkQuan(q)) {
				this.set('quantity', q);
				this.collection.trigger('changeQuantity', this);
			} else {
				this.trigger('change'); //сбрасываем введенное число, если оно не прошло проверку корректности
			}
		},
		quanUp: function (step) {
			var quantity = parseInt(this.get('quantity'));
			var limit = parseInt(this.get('amount'));
			if (quantity < limit) {
				quantity++;
			} else {
				quantity = limit;
			}
			this.set('quantity', quantity);
			this.collection.trigger('changeQuantity', this);
		},
		quanDown: function (step) {
			var q = parseInt(this.get('quantity'));
			if (q > 0) {
				q--;
			} else {
				q = 0;
			}
			this.set('quantity', q);
			this.collection.trigger('changeQuantity', this);
			return (q > 0);
		},
		addToCart: function () {
			this.quanUp();
			/*Выбираем из модели товара необходимые для передачи в корзину свойства*/
			var basketAttrs = ['type', 'id', 'pid', 'lotid', 'title', 'cost', 'amount', 'store', 'quantity', 'stackCost', 'unit', 'currency', 'stack'],
				basketData = {},
				item = this;
			if (item.get('quantity') <= item.get('amount')) {
				_.map(basketAttrs, function (attr) {
					var value = item.get(attr);
					if (value !== undefined) basketData[attr] = value;
				});
				this.trigger('addToCart', basketData);
				basketCollection.updateBasket(basketData);
			}
		},
		checkQuan: function (q) {
			if (q === undefined) q = parseInt(this.get('quantity'));
			return (q <= parseInt(this.get('amount')) && q >= 0);
		},
		/*updateStorage - сохранение выбранного пользователем срока хранения*/
		updateStorage: function (storageId) {
			var storage = this.get('storage');
			var storageCost = '';
			_.map(storage, function (s) {
				if (parseInt(s.id) === parseInt(storageId)) {
					s.selected = true;
					storageCost = s.cost;
				} else s.selected = false;
			});
			this.set('storage', storage);
			this.set('storageCost', storageCost);
			this.trigger('changeStorage', this);
		},
		/**checkStorage - проверка соответствия срока хранения количеству товаров
		 * Сраатывает при изменении количества товара в корзине.
		 * Если количество товара меньше выбранного срока хранения, то пытается выбрать другой максимально подходящий срок
		 * или сбрасывает хранение вовсе, если товара меньше минимального срока хранения.
		 * */
		checkStorage: function () {
			var q = this.get('quantity'),
				storage = this.get('storage'),
				selected = _.findWhere(storage, {
					selected: true
				});
			if (selected) {
				if (parseInt(q) < parseInt(selected.duration)) {
					_.map(storage, function (item) {
						item.selected = false;
					});
					var total = storage.length,
						newStorageCost = '';
					while (total > 0) {
						total--;
						if (parseInt(storage[total].duration) <= q) {
							newStorageCost = storage[total].cost;
							storage[total].selected = true;
							total = 0;
						}
					}
					this.set('storageCost', newStorageCost);
				}
			}
		}
	});
	/*Модель товара в корзине*/
	KApp.Models.BasketItemModel = Backbone.Model.extend({
		defaults: {
			id: 1,
			pid: '',
			lotid: '',
			title: 'Тестовый сорт',
			stack: 10,
			stackCost: 0,
			quantity: 1,
			amount: '',
			unit: 'кг',
			cost: 0,
			sum: 0,
			oldSum: 0,
			store: '0',
			roastFlag: false,
			lang: {
				removeConfirm: 'Вы действительно хотите удалить товар из корзины?',
				noStack: 'до %',
				stack: ''
			}
		},
		initialize: function () {
			this.calc();
			this.on('change roastChanged', this.calc, this); //пересчитываем
		},
		calc: function () {
			var type = this.get('type');
			switch (type) {
			case 'coffee':
				this.calcCoffee();
				break;
			case 'farmer-coffee':
				this.calcFarmerCoffee();
				break;
			default:
				this.calcOther();
				break;
			}
		},
		calcCoffee: function () {
			var quantity = parseInt(this.get('quantity')),
				stack = parseInt(this.get('stack')), //размер мешка (для скидки)
				cost = parseFloat(this.get('cost')), //цена полная
				stackCost = parseFloat(this.get('stackCost')), //цена со скидкой (за полный мешок)
				roastFlag = this.get('roastFlag'), //жарить/нежарить
				sum = '',
				oldSum = false,
				div = function (val, by) { //деление нацело
					return (val - val % by) / by;
				};
			if (roastFlag === undefined) roastFlag = false;
			if (!roastFlag) {
				if (stackCost > 0 && stackCost < cost && quantity >= stack) {
					var stackPrice = div(quantity, stack) * stack * stackCost, //цена на позиции со скидкой (полные мешки)
						remPrice = (quantity % stack) * cost; //цена на остаточные килограммы
					sum = stackPrice + remPrice;
					oldSum = cost * quantity;
				} else {
					sum = quantity * cost;
					oldSum = false;
				}
			} else { //если указана обжарка, то считаем все килограмы по пониженной цене
				sum = stackCost * quantity;
				oldSum = cost * quantity;
			}
			//форматируем суммы перед записью
			sum = KApp.Helpers.moneyFormat.to(sum);
			if (oldSum) oldSum = KApp.Helpers.moneyFormat.to(oldSum);
			this.set({
				sum: sum,
				oldSum: oldSum
			});
		},
		calcFarmerCoffee: function () {
			var quantity = this.get('quantity');
			var cost = this.get('cost'),
				storageCost = this.get('storageCost');
			var targetCost = storageCost || cost;
			var sum;
			if (this.get('currency') === '$') sum = KApp.Helpers.moneyFormat.to(quantity * targetCost);
			else sum = KApp.Helpers.natMoneyFormat.to(quantity * targetCost);
			this.set('sum', sum);
		},
		calcOther: function () {
			var quantity = this.get('quantity');
			var cost = this.get('cost');
			var sum;
			if (this.get('qurrency') === '$') sum = KApp.Helpers.moneyFormat.to(quantity * cost);
			else sum = KApp.Helpers.natMoneyFormat.to(quantity * cost);
			this.set('sum', sum);
		},
		checkLimits: function () {
			var defLimit = parseInt(this.get('defLimit')),
				stack = parseInt(this.get('stack')),
				quantity = parseInt(this.get('quantity'));
			var limit = Math.min(defLimit, stack);
			if (quantity > limit) {
				this.set('quantity', limit);
			}
		},
		/*getKgWeight - возвращает вес позиции в килограммах*/
		getKgWeight: function () {
			var type = this.get('type');
			var total = 0;
			switch (type) {
			case 'coffee':
			case 'farmer-coffee':
				total = 0;
				var unit = this.get('unit'),
					quantity = this.get('quantity');
				//если килограммы, то килограммы
				if (unit === 'кг') total = quantity;
				else //иначе - количество * размер мешка
					total = quantity * this.get('pack');
				break;
			default:
				break;
			}
			return total;
		},
		/*Расчет графика отгрузок при активной опции хранения*/
		getStorageTiming: function () {
			if (typeof ARRIVE_MONTH === 'undefined') return false;
			var storage = this.get('storage'),
				selected = _.findWhere(storage, {
					selected: true
				}),
				duration = selected.duration,
				totalWeight = this.getKgWeight(),
				months = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];
			var count = 0,
				timing = [],
				monthCorrect = 0;
			while (count < selected.duration) {
				var monthId = ARRIVE_MONTH + count - monthCorrect;
				if (monthId > 10) monthCorrect = 12;
				var data = {
					columnName: duration,
					weight: Math.round((totalWeight / duration)),
					month: months[monthId]
				}
				timing.push(data);
				count++;
			}
			return timing;
		}
	});
	/*Модель итогов корзины*/
	// KApp.Models.BasketSummaryModel = Backbone.Model.extend({
	//     defaults: {
	//         sum: 0,
	//         national: 0,
	//         quantity: 0,
	//         currency: "₽"
	//     }
	// });
	/*Модель плательщика*/
	KApp.Models.PayerModel = Backbone.Model.extend({
		defaults: {
			id: '000',
			name: 'Тестовый плательщик',
			selected: false,
			address: ""
		}
	});
	KApp.Models.SimplifyBasketItem = Backbone.Model.extend({
		defaults: {
			id: '',
			pid: '',
			lotid: '',
			quantity: '',
			store: ''
		}
	});
	/*Модель магазина/склада*/
	KApp.Models.StoreModel = Backbone.Model.extend({
		defaults: {
			id: 2,
			name: 'Имя Склада',
			address: '',
			worktimes: '',
			deliveryTax: 3500, //стоимость доставки (если не добран бесплатный лимит)
			freeDelivery: 300, //количество кофе (в килограммах) для бесплатной доставки
			unit: '',
			selected: false,
		},
		calculateFreeDelivery: function (weight) {
			var limit = this.get('freeDelivery');
		}
	});
	/*Модель варианта доставки*/
	KApp.Models.DeliveryVarModel = Backbone.Model.extend({
		defaults: {
			storeid: "", // по этому полю будут фильтроваться службы доставки, в зависимости от выбранного магазина
			name: "",
			address: "",
			worktimes: "",
			description: "",
			type: "",
			deliveryTax: 0,
			selected: false,
			freeDelivery: false,
			enabled: true
		},
		getCost: function () {
			var cost = this.get('deliveryTax');
			if (this.get('freeDelivery')) cost = 0;
			return cost;
		}
	});
	/*Модель пользовательского адреса (при выборе доставки)*/
	KApp.Models.UserDeliveryDataModel = Backbone.Model.extend({
		defaults: {
			city: '',
			street: '',
			house: '',
			building: '',
			office: '',
			contactPerson: '',
			contactPhone: '',
			worktimes: '',
			errorsBuffer: [],
			endpoint: 'moscow'
		},
		initialize: function () {
			// this.set('city', 'Москва', {silent: true});
		},
		markErrors: function () {
			var fields = ['city', 'street', 'house', 'contactPerson', 'contactPhone'],
				errorsBuffer = [],
				model = this;
			_.map(fields, function (field) {
				if (model.get(field) === '') {
					errorsBuffer.push(field); //записываем ошибку, чтобы пометить поле
				}
			});
			this.set('errorsBuffer', errorsBuffer);
			return errorsBuffer;
		},
		/**Проверка заполненности полей формы*/
		checkForComplete: function () {
			var errors = this.markErrors(),
				complete = false;
			if (errors.length === 0) complete = true;
			return complete;
		}
	});
	/*Модель всплывающего уведомления (алерт)*/
	KApp.Models.Alert = Backbone.Model.extend({
		defaults: {
			code: '',
			type: 'success',
			text: 'Текст уведомления'
		}
	});
	/*Модель информационного сообщения (попап)*/
	KApp.Models.InfoMessageModel = Backbone.Model.extend({
		defaults: {
			status: 'error',
			title: 'Ошибка',
			message: 'Попробуйте снова',
			sizeClass: 'wf-popup-medium',
			orderId: ''
		}
	});
	/*Модель подтверждения*/
	KApp.Models.ConfirmModel = Backbone.Model.extend({
		defaults: {
			title: "Подтверждение действия",
			oktext: "Да",
			notext: "Нет",
			sizeClass: 'wf-popup-small',
			confirm: true,
		},
		confirmCallback: function () {}
	});
	/*Модель элемента фильтра*/
	KApp.Models.FilterItemModel = Backbone.Model.extend({
		defaults: {
			field: '', //поле для фильтрации
			caption: 'Название фильтра',
			values: [], //значения фильтрации
			type: 'select', //тип,
			size: 'col-md-6', //разммер ячейки по умолчанию
			clientId: '' // служебное поле
		},
		initialize: function () {
			this.on('change:value', this.updateFilter, this); //слушаем изменение текущего фильтра
			var vals = this.get('values'),
				type = this.get('type'),
				clientId = type + '-' + Date.now(); //заполням поле clientId (нужно для рендеринга)
			this.set('clientId', clientId, {
				silent: true
			});
			switch (type) {
			case "select":
				vals = new KApp.Collections.SelectCollection(vals);
				this.set('values', vals);
				vals.on('change', this.updateSelectFilter, this);
				break;
			default:
				break;
			}
			this.set('values', vals, {
				silent: true
			});
		},
		/*Обновляем текущий фильтр типа селект*/
		updateSelectFilter: function (model) {
			var selectedId = model.get('id');
			this.set('value', selectedId);
		},
		/*Отправляем события коллекции фильтров (после этого произойдёт фильтрация)*/
		updateFilter: function () {
			this.collection.trigger('changeFilter', this.attributes);
		}
	});
	KApp.Models.SelectModel = Backbone.Model.extend({
		defaults: {
			key: "",
			value: "",
			selected: false
		}
	});
	KApp.Models.BalanceModel = Backbone.Model.extend({
		defaults: {
			balance: 0
		},
		updateBalance: function (data) {
			if (typeof data.balance !== "undefined") {
				this.set('balance', data.balance);
			}
		}
	})
});
$(function () {
	/*Модель заказа*/
	KApp.Models.OrderModel = Backbone.Model.extend({
		defaults: {
			items: [], //товары в заказе
			additional: {}, // доп.данные
			payer: {}, //информация о плательщике
			payersList: '', //список плательщиков
			userDeliveryData: '', //данные для доставки
			delivery: '', //
			deliveryCost: '', //стоимость доставки
			deliveryName: '', //название доставки
			deliveryVariants: [], //варианты доставки
			sum: 0, //сумма заказа
			quantity: 0, //количество позиций
			unit: '', //единица измерения
			national_sum: '', //национальная сумма
			totalWeight: 0, //вес заказа
			freeShortage: null, //Нехватка до бесплатной доставки
			freeShortagePercent: null, //нехватка до бесплатной доставки (в процентах)
			freeShortageScale: 0, //
			currentStep: 0, //текущий шаг (0 - корзина, 1 - подтверждение),
			mobileSummary: '',
			errors: {
				dateUndefined: 'Не выбрана дата обжарки',
				basketUndefined: 'Не добавлены товары в корзину',
			},
			/**28.02.2020 - изменили roast на needRoast
			 * Этот параметр используется в окне подтверждения заказа, если true, то не отображать вариант "Доставка"
			 * */
			needRoast: false, //нужно ли жарить (если true, то не показываем доставку)
			store: null, //текущий магазин,
			lang: {
				confirmOrderBtn: 'Сформировать счёт',
				makeOrderBtn: 'Подтвердить заказ'
			},
			state: ''
		},
		initialize: function () {
			if (typeof payers === "undefined") return false;
			this.initPayers();
			this.initUserDeliveryData();
			this.calcSummary();
			this.calcMobileSummary();
			this.initSearch();
			this.initDelivery();
			//this.on('change:store change:deliveryVariants', this.initDelivery, this);
			this.listenTo(this.get('payersList'), 'change', this.updateSelectedPayer, this);
			this.on('freeDeliveryUpdated', this.updateDeliveryVariants, this);
			this.on('change', this.checkOrder, this);
			this.on('change', this.prepareOrder, this);
			//    this.on('itemsUpdated', this.basketHandler, this);
			this.on('change:needRoast, change:delivery', this.calcSummary, this);
			this.on('itemsUpdated', this.removeBasketItem, this);
			this.on('needToMake', this.sendOrder, this);
			if (this.get('cargoLimits')) this.setCargoLimits();
			//    this.updateSelectedPayer();
		},
		/*Варианты доставки*/
		initDelivery: function () {
			var deliveries = this.get('deliveryVariants');
			// console.log(deliveries);
			if (deliveries.length) {
				var selectedVar = deliveries.findWhere({
					selected: true
				}); //выбранная служба доставки
				deliveries.on('change', this.updateSelectedDelivery, this);
				deliveries.on('change', this.calcFreeDelivery, this);
				if (typeof selectedVar !== "undefined") this.updateSelectedDelivery(selectedVar);
				else {
					selectedVar = deliveries.at(0);
					selectedVar.set('selected', true);
					this.updateSelectedDelivery(selectedVar);
				}
			}
		},
		updateDeliveryVariants: function (data) {
			var deliveryVariants = this.get('deliveryVariants');
			if (deliveryVariants && deliveryVariants.length) {
				deliveryVariants.setFreeDelivery(data.freeDelivery);
				deliveryVariants.checkThreshold(data.totalWeight);
			}
		},
		/*Плательщики*/
		initPayers: function () {
			//payers - глобальная переменная
			var payersProfiles = payers || [];
			var payersCollection = new KApp.Collections.PayersCollection(payersProfiles);
			var selectedPayer = payersCollection.getSelectedPayer();
			window.selectedPayer = selectedPayer
			this.set('payersList', payersCollection, {
				silent: true
			});
			this.set('payer', selectedPayer, {
				silent: true
			});
		},
		/*Корзина*/
		initBasket: function () {
			if (typeof BASKET_COOKIE !== "undefined") {
				store.removeExpiredKeys();
				var basketCollection = new KApp.Collections.BasketCollection();
				var basketName = BASKET_COOKIE;
				this.set('basketName', basketName, {
					silent: true
				});
				var basket = store.get(basketName);
				if (typeof basket !== 'undefined') {
					var decompressedBasket = JSON.parse(basket);
					basketCollection.reset(decompressedBasket);
				}
				this.set('items', basketCollection);
				this.trigger('itemsLoaded', basketCollection);
				this.on('orderSuccess', this.clearOrder, this); //чистим заказ после создания
				basketCollection.on('removeBasketItem', this.removeBasketItem, this);
				basketCollection.on('change remove reset', this.basketHandler, this);
				//this.trigger('showStorageCalendar', this);
				this.basketHandler();
			}
		},
		/*Поиск по организациям*/
		initSearch: function () {
			//Поиск по сайту
			var orgSearch = this.get('orgSearch');
			if (orgSearch) {
				this.listenTo(orgSearch, 'resultSelected clearSelection', this.updateSearchOrg);
			}
		},
		updateSearchOrg: function (data) {
			var org_id = '';
			if (data) org_id = data.ID;
			this.set('user_org', org_id, {
				silent: true
			});
		},
		/*cargoControl - проверяет заполненность контейнера,
		 * когда контейнер заполнен, обновляет поле cargoLimitOver в заказе
		 * возможные значения cargoLimitOver - true или false
		 * */
		cargoControl: function () {
			var lim = this.get('cargoLimits'),
				items = this.get('items'),
				stackSize = 1,
				available = lim.total - lim.reserved;
			if (items.length) {
				var current = items.getTotalWeight();
				stackSize = items.getStackSize();
				available = lim.total - (lim.reserved + current);
			}
			var limitOver = available < stackSize;
			this.set('cargoLimitOver', limitOver);
			return this;
		},
		/*Подготовка данных о загруженности контейнера (при доставке от фермера)*/
		setCargoLimits: function () {
			var lim = this.get('cargoLimits'),
				items = this.get('items'),
				stackSize = 1;
			lim.current = 0;
			if (items.length) {
				lim.current = items.getTotalWeight();
				stackSize = items.getStackSize();
			}
			lim.available = lim.total - (lim.reserved + lim.current);
			if (lim.available < 0) lim.available = 0;
			lim.percent = 1 - lim.available / lim.total;
			this.set('cargoLimits', lim);
			this.trigger('cargoLimitsUpdated', lim);
		},
		/*Обновление выбранного товара в корзине*/
		updateBasketItem: function (item) {
			var basketCollection = this.get('items');
			basketCollection.updateBasket(item);
		},
		removeBasketItem() {
			var items = this.get('items');
			this.trigger('basketItemRemoved', items);
		},
		/*Обработчики изменения корзины*/
		basketHandler: function () {
			this.calcSummary();
			this.calcMobileSummary();
			this.calcFreeDelivery();
			this.checkRoast();
			this.saveBasketItems();
			if (this.get('cargoLimits')) {
				this.setCargoLimits();
				this.cargoControl();
			}
			//   this.setCargoLimits();
		},
		updateOrder: function (model) {
			if (typeof model !== "undefined") {
				var collection = model.collection;
				this.set('items', collection, {
					silent: true
				});
				this.trigger('itemsUpdated', collection);
			}
		},
		/*Подсчёт итогов заказа*/
		calcSummary: function () {
			var itemsCollection = this.get('items'), //корзина
				items = this.get('items')
				.models, //товары в корзине
				deliveryVars = this.get('deliveryVariants'); //варианты доставки
			var summary = {
				sum: 0, //цена в $
				national_sum: '', //цена в национальной валюте
				quantity: 0, //количество позиций
				unit: 'шт.', //единица измерения позиций (кг или шт.)
				totalWeight: 0, //вес заказа
				deliveryCost: 0, //стоимость доставки
				deliveryName: '' //название текущего варианта доставки
			};
			if (deliveryVars && deliveryVars.length) {
				summary.deliveryCost = deliveryVars.getCost();
				summary.deliveryName = deliveryVars.getName();
			}
			if (items && items.length > 0) {
				summary.quantity = items.length;
				summary.totalWeight = itemsCollection.getTotalWeight();
				summary.currency = items[0].get('currency');
				summary.unit = items[0].get('unit');
				//форматируем суммы
				var cleanSum = itemsCollection.getBasketSum();
				var basketSum;
				if (summary.currency === '$') {
					summary.national_sum = KApp.Helpers.natMoneyFormat.to(cleanSum * NAT_CURRENCY_VALUE);
					basketSum = KApp.Helpers.moneyFormat.to(cleanSum);
				} else basketSum = KApp.Helpers.natMoneyFormat.to(cleanSum);
				summary.sum = basketSum;
			}
			_.map(summary, function (val, key) {
				this.set(key, val);
			}.bind(this));
			this.trigger('summaryUpdated');
		},
		calcMobileSummary: function () {
			var items = this.get('items');
			var summaryStr = '';
			if (items.length) {
				summaryStr = items.length + ' ' + KApp.Helpers.numerals(items.length, ['позиция', 'позиции', 'позиций']) + ' на сумму ' + this.get('sum');
			}
			this.set('mobileSummary', summaryStr);
		},
		/*Подсчет бесплатной доставки*/
		calcFreeDelivery: function () {
			var store = this.get('store');
			if (store) {
				var totalWeight = this.get('totalWeight');
				var data = {
					freeShortage: null,
					freeShortagePercent: null,
					freeShortageScale: null,
					freeDelivery: null,
					totalWeight: totalWeight
				};
				if (totalWeight) {
					var fd = store.freeDeliveryLimit;
					var freeShortage = Math.abs(fd - totalWeight),
						freeShortagePercent = totalWeight / fd * 100;
					if (freeShortagePercent > 100) freeShortagePercent = 100;
					data.freeShortage = freeShortage; //не хватает до бесплатной доставки
					data.freeShortagePercent = freeShortagePercent; //процент добора до беслатной доставки
					data.freeShortageScale = freeShortagePercent / 100; //процент добора до беслатной доставки
					data.freeDelivery = (freeShortagePercent >= 100);
				}
				_.map(data, function (val, key) {
					this.set(key, val, {
						silent: true
					});
				}.bind(this));
				this.trigger('freeDeliveryUpdated', data);
			}
		},
		/*Проверка, нужно ли что-то жарить в заказе*/
		checkRoast: function () {
			var items = this.get('items'),
				roastItems = items.where({
					'roastFlag': true
				});
			this.set('needRoast', (roastItems.length > 0));
		},
		updateSelectedPayer: function (payer) {
			if (typeof payer === "undefined") payer = this.get('payersList')
				.findWhere({
					selected: true
				});
			if (payer.get('selected') === true) this.set('payer', payer.attributes);
			console.log(`${payer.attributes.address}`, 234)
			this.attributes.deliveryVariants.models[2].set("description", `${payer.attributes.address}`)
			this.trigger("freeDeliveryUpdated", this)
			if (this.attributes.delivery.type == "external") {
				// console.log("biba")
				// this.attributes.delivery.description = payer.attributes.address
				// this.updateSelectedDelivery( this.attributes.delivery)
			}
			// console.log(1, this.attributes.delivery)
		},
		updateSelectedDelivery: function (delivery) {
			if (typeof delivery !== "undefined") {
				if (delivery.get('selected') === true) {
					this.set('delivery', delivery.attributes);
				} else {
					this.set('delivery', '', {
						silent: true
					});
				}
			}
		},
		initUserDeliveryData: function (order, deliveryData) {
			var dp = {};
			if (typeof DELIVERY_PROFILE !== "undefined") dp = DELIVERY_PROFILE;
			// console.log(dp);
			var deliveryData = new KApp.Models.UserDeliveryDataModel(dp);
			this.set('userDeliveryData', deliveryData);
			deliveryData.on('change', this.checkOrder, this);
		},
		/**Проверка заказа на корректность*/
		checkOrder: function () {
			//console.log('check order');
		},
		checkDelivery: function () {
			var delivery = this.get('delivery'),
				userDeliveryData = this.get('userDeliveryData');
			//если доставка не определена (или не нужна)
			if (typeof delivery === 'undefined' || delivery === '') {
				return {
					result: true
				};
			}
			var checkResult = {
				result: false,
				errorCode: 102
			};
			if (typeof delivery === "undefined" || delivery === '') {
				checkResult.result = false;
				checkResult.errorCode = 102;
			} else {
				if (delivery.type === 'self') {
					checkResult = {
						result: true
					}
				} else {
					var checkDeliveryData = userDeliveryData.checkForComplete();
					if (!checkDeliveryData) checkResult.errorCode = 103;
					else checkResult.result = true; //всё ок
				}
			}
			return checkResult;
		},
		/**Подготовка данных заказа к отправке на сервер (чтобы не отправлять всё, что есть лишнее)*/
		prepareOrder: function () {
			var prepared,
				orderData = {};
			orderData.items = this.get('items');
			orderData.additional = this.get('additional');
			orderData.payer = this.get('payer');
			orderData.delivery = this.get('delivery');
			orderData.userDeliveryData = this.get('userDeliveryData')
				.attributes;
			var search = this.get('orgSearch');
			if (search) {
				var user_org = this.get('user_org');
				if (user_org) orderData.user_org = search.attributes.selectedId;
			}
			prepared = JSON.stringify(orderData);
			return prepared;
		},
		checkStorageItems: function () {
			var items = this.get('items');
			var storageItems = items.getOnlyStorageItems();
			return storageItems.length;
		},
		/**Отправка заказа*/
		sendOrder: function () {
			this.checkOrder();
			var checkDelivery = this.checkDelivery();
			//Если c доставкой всё ок
			if (checkDelivery.result) {
				var order = this,
					orderDataStr = this.prepareOrder();
				this.set('state', 'loading');
				$.ajax({
					url: ORDER_URL,
					data: {
						sessid: BX.bitrix_sessid(),
						jsonData: orderDataStr
					},
					method: 'post',
					/*success - обработка ответа с сервера
					 * @param {boolean} res.success - успех или ошибка
					 * @param {string} message - текстовое сообщение
					 * @param {number} orderId - id заказа (в случае успеха)
					 * @param {string} roastRedirect - редирект на страницу вывбора даты обжарки
					 * */
					success: function (res) {
						var data = {
							status: res.status,
							title: "Ошибка",
							message: res.message
						};
						if (res.success) {
							data.status = "success";
							data.title = "Ваш Заказ успешно создан.";
							data.message = res.message;
						}
						if (res.bonuses) {
							data.bonuses = res.bonuses
						}
						data.orderId = res.orderId || '';
						if (res.farmersUrl) data.farmersUrl = res.farmersUrl;
						if (typeof res.balance !== `undefined`) {
							data.balance = res.balance;
						}
						order.set('currentStep', 2);
						//если есть товары на хранение (Заказ от фермера), то подаем сингал для отображения графика хранения
						var checkStorageItems = order.checkStorageItems();
						if (checkStorageItems) {
							// order.trigger('showStorageCalendar', order);
						}
						order.trigger('orderSuccess', data);
						order.set('state', res.status);
						/*Редирект на бронирование ростера, если в заказе был кофе с обжаркой*/
						if (res.roastRedirect) setTimeout(function () {
							location.href = res.roastRedirectURL;
						}, 5000);
					},
					error: function (err) {
						console.log('error', err);
					}
				});
			} else {}
		},
		saveBasketItems: function () {
			var basketName = this.get('basketName'),
				itemsCollection = this.get('items');
			if (itemsCollection) {
				var items = itemsCollection.models;
				var compressed = JSON.stringify(items);
				var expiredDate = new Date()
					.getTime() + 2 * 24 * 60 * 60 * 1000;
				//исправление бага invalidArgument для IE11
				try {
					store.set("__test_store_", [{
						"id": "10",
						"keys": "dev"
					}]);
				} catch (e) {
					console.warn("Store fallback!");
					store = {
						get: function (key) {
							return JSON.parse(localStorage.getItem(key));
						},
						set: function (key, val) {
							localStorage.setItem(key, JSON.stringify(val));
						},
						each: function () {
							console.log('each localstorage');
						}
					};
				}
				return store.set(basketName, compressed, expiredDate.toString());
			}
		},
		/*Сброс заказа после успешного создания*/
		clearOrder: function () {
			var items = this.get('items');
			items.reset();
		}
	});
});
$(function () {
	/*Список товаров (каталог)*/
	KApp.Collections.ProductsCollection = Backbone.Collection.extend({
		model: KApp.Models.ProductModel,
		initialize: function () {
			this.on('filtered', this.filterItems, this);
		},
		syncQuantities: function () { //пересчет количества товара
			var args = _.toArray(arguments),
				basket;
			_.map(args, function (arg) {
				if (typeof arg.models !== "undefined") basket = arg;
			});
			if (typeof basket !== undefined) {
				var simplifyBasket = basket.simplify();
				if (simplifyBasket.length) {
					this.each(function (item) {
						this.syncOne(item, simplifyBasket);
					}, this);
				} else {
					this.each(function (item) {
						item.set('quantity', 0);
					})
				}
			} else {}
		},
		syncOne: function (item, basket) {
			var type = item.get('type'),
				basketItem;
			switch (type) { //в зависимости от типа товара разные поля для выбора товаров в корзине
			case "coffee":
				var lotid = item.get('lotid');
				basketItem = basket.findWhere({
					lotid: lotid
				});
				break;
			default:
				basketItem = basket.findWhere({
					id: item.get('id')
				});
				break;
			}
			if (basketItem) {
				item.set('quantity', basketItem.get('quantity'));
				if (type === 'farmer-coffee') {
					item.set('storage', basketItem.get('storage'), {
						silent: true
					});
					item.set('storageCost', basketItem.get('storageCost'));
				}
			} else item.set('quantity', 0);
		},
		reload: function (storeModel) {
			var storeId = storeModel.get('id');
			if (typeof products !== "undefined" && typeof storeId !== "undefined") {
				var newProducts = _.where(products, {
					store: storeId
				});
				newProducts = _.sortBy(newProducts, 'oldCost'); // сортируем по наличию скидки
				this.reset(newProducts);
				this.trigger('updated');
			}
		},
		/*Возвращает данные для фильтрации каталога*/
		getFiltersData: function (filtersList) {
			var filters = [];
			_.map(filtersList, function (item, i) {
				var f = [], //фильтры
					current = item;
				this.map(function (model) {
					f.push(model.get(item.field));
				});
				switch (item.field) {
				case "region":
					var first = {
						id: 0,
						name: item.caption,
						selected: true
					};
					f = _.uniq(f, function (x) {
						return x.id;
					});
					f.unshift(first);
					break;
				default:
					break;
				}
				current.values = f;
				filters.push(current);
			}.bind(this));
			return filters;
		},
		/*@method filterCollection - Фильтрация коллекции по полю
		 * @param {string} data.field - поле для фильтрации
		 * @param {string} data.type - тип фильтрации
		 * @param {string} data.value - значение
		 * */
		filterCollection: function (data) {
			if (typeof data === 'undefined') return false;
			var filtered = [];
			var allIds = this.pluck('id');
			switch (data.field) {
			case 'region': //фильтр по региону
				if (parseInt(data.value) === 0) {
					this.trigger('unfiltered', allIds);
				} else {
					filtered = this.filter(function (model, iterator, collection) {
						var region = model.get('region');
						return region.id !== data.value;
					});
					filtered = _.pluck(filtered, 'id');
				}
				break;
			case 'name': //фильтр по имени (пользовательский ввод)
				if (data.value) {
					filtered = this.filter(function (model) {
						var name = model.get('title')
							.toLowerCase();
						var userInput = data.value.toLowerCase();
						return name.indexOf(userInput) < 0;
					});
					filtered = _.pluck(filtered, 'id');
				} else {
					this.trigger('unfiltered', allIds);
				}
				break;
			default:
				break;
			}
			this.trigger('filtered', filtered);
		},
		filterItems: function (ids) {
			this.map(function (model) {
				if (_.indexOf(ids, model.get('id')) >= 0) model.set('filtered', true);
				else model.set('filtered', false);
			});
		},
		/*controlLimits - включение/отключение возможности добавления в корзину
		 * @param {object} order - модель заказа
		 * @param {boolean} overLimit - превышен ли лимит (да/нет)
		 * */
		controlLimits: function (order, overLimit) {
			this.each(function (model) {
				model.set('canAddToCart', !overLimit);
			}, this)
		},
		needToHide: function () {
			this.trigger('needToHide');
		}
	});
	/*Список товаров в корзине*/
	KApp.Collections.BasketCollection = Backbone.Collection.extend({
		model: KApp.Models.BasketItemModel,
		properties: {
			selectedDate: '',
			store: '',
			totalWeight: '',
			quantity: '',
			national_sum: '',
			sum: '',
			roast: false,
			deliveryTax: '',
			freeDelivery: '',
		},
		initialize: function () {
			this.on('remove reset', this.removeBasketItem, this);
		},
		updateBasket: function (item) {
			var quantity = item.get('quantity');
			var type = item.get('type');
			if (quantity > 0) {
				var sameFilter = {
					pid: item.get('pid')
				}; //критерий поиска такого же товара в корзине
				if (item.get('type') === "probe") //если пробник, то ищем по id
					sameFilter = {
						id: item.get('id')
					};
				var sameProduct = this.findWhere(sameFilter);
				if (sameProduct) {
					switch (type) {
					case 'farmer-coffee':
						var fieldsTySync = ['storage', 'storageCost'];
						_.map(fieldsTySync, function (fieldname) {
							sameProduct.set(fieldname, item.get(fieldname));
						});
						break;
					default:
						break;
					}
					sameProduct.set('quantity', quantity);
				} else {
					var basketItem = new KApp.Models.BasketItemModel(item.attributes);
					this.add(basketItem);
				}
			} else {
				this.remove(item);
			}
			this.trigger('change');
		},
		addNewItem: function (item, index) {
			var basketItem = new KApp.Models.BasketItemModel(item);
			this.add(basketItem, {
				at: index,
				remove: false
			}); //добавляем товар в корзину
			this.trigger('change');
		},
		/*Консолидация товаров по id*/
		simplify: function () {
			if (this.length === 0) return false;
			var first = this.at(0);
			var type = first.get('type');
			var uniqField = 'id';
			if (type === 'coffee') uniqField = 'lotid';
			var uniqProducts = _.uniq(this.pluck(uniqField));
			var simplifyCollection = new KApp.Collections.BasketCollection();
			var iterate = 0;
			_.map(uniqProducts, function (lotid) {
				var sameGroup = [];
				if (type == 'coffee') sameGroup = this.where({
					lotid: lotid
				});
				else sameGroup = this.where({
					id: lotid
				});
				var sameQuan = 0, //консолидированная количество товаров с одинаковым id (жареный и не жаренный);
					props = ['id', 'pid', 'type', 'store', 'title', 'unit'],
					data = {};
				if (sameGroup.length) {
					var type = sameGroup[0].get('type'); //тип продукта
					if (type === 'farmer-coffee') props.push('storage', 'storageCost');
					if (type === 'coffee') props.push('lotid');
					_.map(sameGroup, function (item) {
						_.map(props, function (propname) {
							if (item.get(propname)) data[propname] = item.get(propname);
						});
						var q = item.get('quantity');
						if (q) sameQuan += parseInt(q);
						data.quantity = sameQuan;
					});
					var itemGroup = new KApp.Models.SimplifyBasketItem(data);
					simplifyCollection.add(itemGroup);
					iterate++;
				}
			}, this);
			return simplifyCollection;
		},
		/*Перезагрузка корзины при смене склада*/
		reload: function (basketName) {
			//console.log('reload', arguments);
			if (typeof basketName === 'undefined') basketName = window.basketName;
			//console.log('basketName on reload: ' + basketName);
			var newBasketItems = store.get(basketName); //получаем из localstorage товары из текущей корзины
			if (newBasketItems) {
				newBasketItems = KApp.Helpers.decompress(newBasketItems);
				this.trigger('updated');
				this.reset(newBasketItems); //очищаем текущую корзину
			} else {
				this.reset();
				console.log('в новой корзине пока нет товаров');
			}
		},
		/*Обновляем информацию о выбранном магазине*/
		updateStoreInfo: function (currentStore) {
			var fields = ['deliveryTax', 'freeDelivery', 'unit', 'id'];
			_.map(fields, function (field) {
				var propField = field;
				if (field === 'id') propField = 'store';
				this.properties[propField] = currentStore.get(field);
			}.bind(this));
		},
		removeBasketItem: function () {
			this.trigger('removeBasketItem', this);
		},
		/*getTotalWeight - возвращает полный вес заказа*/
		getTotalWeight: function () {
			var totalWeight = 0;
			this.map(function (item) {
				var weight = item.getKgWeight();
				if (weight !== false) totalWeight += parseInt(weight);
			});
			return totalWeight;
		},
		/*getBasketSum - возвращает сумму заказа*/
		getBasketSum: function () {
			var currency = this.at(0)
				.get('currency');
			var basketSum = 0;
			this.map(function (item) {
				if (currency === '$') basketSum += KApp.Helpers.moneyFormat.from(item.get('sum'));
				else basketSum += KApp.Helpers.natMoneyFormat.from(item.get('sum'));
			});
			return basketSum;
		},
		getStackSize: function () {
			var stack = false;
			if (this.length > 0) {
				var first = this.at(0);
				stack = first.get('stack');
			}
			return parseInt(stack);
		},
		/*getOnlyStorageItems - возвращает только товары, для которых указана опция хранения*/
		getOnlyStorageItems: function () {
			var filtered = this.filter(function (model) {
				var storage = model.get('storage');
				var selected = _.findWhere(storage, {
					selected: true
				});
				return (typeof selected !== 'undefined');
			});
			return filtered;
		}
	});
	/*Список плательщиков*/
	KApp.Collections.PayersCollection = Backbone.Collection.extend({
		model: KApp.Models.PayerModel,
		changePayer: function (payerid) {
			var curr = this.findWhere({
				selected: true
			});
			if (curr && curr.get('id') === payerid) return false;
			var newSelected = this.findWhere({
				'id': payerid
			});
			newSelected.set('selected', true);
			window.selectedPayer = newSelected.attributes
			// console.log(window.selectedPayer)
			// console.log(KApp.Collections.DeliveryCollection)
			if (curr) curr.set('selected', false);
		},
		getSelectedPayer: function () {
			var selected = this.findWhere({
					'selected': true
				}),
				attributes;
			if (selected === undefined) {
				return [];
			} else {
				attributes = selected.attributes;
			}
			return attributes;
		}
	});
	/*Список магазинов*/
	KApp.Collections.StoresCollection = Backbone.Collection.extend({
		model: KApp.Models.StoreModel,
		initialize: function () {},
		selectStore: function (storeId) {
			if (typeof storeId === "undefined") storeId = this.at(0)
				.get('id');
			var realChange = false;
			var oldSelected = this.findWhere({
				'selected': true
			});
			if (typeof oldSelected !== 'undefined') {
				if (oldSelected.get('id') !== storeId) {
					oldSelected.set('selected', false, {
						silent: true
					});
					realChange = true;
				}
			}
			var selected = this.findWhere({
				id: storeId
			});
			selected.set('selected', true);
			window.basketName = 'coffee_basket_' + storeId; //для получения кук
			if (realChange) this.trigger('changeStore');
		}
	});
	/*Список доставок*/
	KApp.Collections.DeliveryCollection = Backbone.Collection.extend({
		model: KApp.Models.DeliveryVarModel,
		selectDelivery: function (cid) {
			var newModel = this.get(cid);
			var oldModel = this.findWhere({
				selected: true
			});
			// console.log(this)
			if (typeof oldModel !== "undefined") oldModel.set('selected', false);
			newModel.set('selected', true);
		},
		checkThreshold: function (weight) {
			if (typeof weight !== "undefined") {
				this.each(function (model) {
					if (model.get('thresholdShowFrom') && model.get('thresholdShowUntil')) {
						if ((model.get('thresholdShowFrom') < weight) && (model.get('thresholdShowUntil') > weight)) {
							model.set('enabled', true)
						} else {
							model.set('enabled', false)
						}
					}
				});
			}
		},
		setFreeDelivery: function (val) {
			if (typeof val !== "undefined") {
				this.each(function (model) {
					model.set('freeDelivery', val);
				});
			}
		},
		getName: function () {
			var selected = this.findWhere({
				selected: true
			});
			if (selected) {
				return selected.get('name');
			}
		},
		getCost: function () {
			var selected = this.findWhere({
				selected: true
			});
			if (selected) {
				return selected.getCost();
			}
		},
		unselectAll: function () {
			this.each(function (model) {
				model.set('selected', false);
			});
		}
	});
	KApp.Collections.FiltersCollection = Backbone.Collection.extend({
		model: KApp.Models.FilterItemModel,
		initialize: function () {
			this.on('changeFilter', this.notifyUp, this);
		},
		notifyUp: function (data) {
			this.trigger('filterUpdated', data);
		}
	});
	KApp.Collections.SelectCollection = Backbone.Collection.extend({
		model: KApp.Models.SelectModel,
		updateSelected: function (id) {
			var curr = this.findWhere({
				selected: true
			});
			if (curr.get('id') === id) return false;
			var newSelected = this.findWhere({
				'id': parseInt(id)
			});
			curr.set('selected', false, {
				silent: true
			});
			newSelected.set('selected', true);
		}
	});
});
$(function () {
	$.cookie.json = true;
	KApp.Views.CheckoutView = Backbone.View.extend({
		el: '#checkout',
		events: {
			'click .change-step': 'updateCurrentStep'
		},
		initialize: function () {
			if (this.el) this.render();
			else return false;
			this.model.on('change:currentStep', this.changeStep, this);
			this.model.on('orderSuccess', this.showOrderResults, this);
			this.model.on('change:mobileSummary', this.updateMobileSummary, this);
			this.model.on('change:delivery', this.renderDelivery, this);
			//корзина
			var basketView = new KApp.Views.BasketView({
				collection: this.model.get('items')
			});
			//итоги корзины
			if (document.getElementById('basket-summary')) var basketSummary = new KApp.Views.BasketSummaryView({
				model: this.model
			});
			//Шкала заказа
			if (document.getElementById('order-scale')) var deliveryScaleView = new KApp.Views.ScaleView({
				model: this.model
			});
			//Кнопка "Сформировать счёт"
			if (document.getElementById('order-btn-wrapper')) var orderBtn = new KApp.Views.OrderBtnView({
				model: this.model
			});
			//Список плательщиков
			if (this.model.get('payersList')) {
				var payers = this.model.get('payersList');
				var payersListView = new KApp.Views.PayersList({
					collection: payers
				});
			}
			//Лимит по контейнеру
			if (this.model.get('cargoLimits')) this.renderCargoLimits();
			//список доставок
			var deliveryVars = this.model.get('deliveryVariants');
			if (deliveryVars && deliveryVars.length) this.renderDelivery();
			//Поиск по организациям
			if (this.model.get('orgSearch') && ENABLE_SEARCH_ORG) this.renderSearch();
			//мобильное саммари (липкое внизу экрана)
			this.renderMobileSummary();
		},
		render: function () {
			var tpl = KApp.Helpers.template('checkout-tpl');
			this.el.innerHTML = tpl(this.model.attributes);
			// console.log(1,this.model);
		},
		/*Способы доставки*/
		renderDelivery: function () {
			// console.log(this.model.get('payer'))
			if (this.model.get('store')) {
				var deliveryCollection = this.model.get('deliveryVariants'),
					needRoast = this.model.get('needRoast'),
					storeId = parseInt(this.model.get('store')
						.id);
				if (storeId === 3 || !needRoast) {
					var $deliverySection = this.$el.find('#delivery-section');
					var $deliveryWrapper = this.$el.find('#delivery-wrapper');
					if (deliveryCollection.length) {
						var deliveryView = new KApp.Views.DeliveryListView({
							collection: deliveryCollection
						});
						deliveryView.render(storeId);
						if ($deliveryWrapper) $deliveryWrapper.html(deliveryView.$el);
					} else {
						$deliverySection.hide(1);
					}
					var userDeliveryData = this.model.get('userDeliveryData');
					var deliveryForm = new KApp.Views.DeliveryFormView({
						model: this.model
					});
				}
			}
		},
		/*Заполненность контейнера*/
		renderCargoLimits: function () {
			var limits = this.model.get('cargoLimits');
			if (limits) {
				var cargoLimitsView = new KApp.Views.ScaleView({
					model: this.model
				});
			}
		},
		/*Рендеринг поиска по организациям*/
		renderSearch: function () {
			var searchModel = this.model.get('orgSearch');
			if (searchModel) var searchView = new OrgSearch.Views.SearchFieldView({
				model: searchModel
			});
		},
		changeStep: function (model, step) {
			KApp.Helpers.changeStep(model, step);
		},
		updateCurrentStep: function (e) {
			e.preventDefault();
			this.model.set('currentStep', parseInt(e.target.dataset.step));
		},
		showOrderResults: function (data) {
			var info = new KApp.Models.InfoMessageModel(data);
			var view = new KApp.Views.OrderResultsView({
				model: info
			});
		},
		renderMobileSummary: function () {
			var model = this.model;
			var mobileSummary = new KApp.Views.BasketSummaryMobieView({
				model: model
			});
		}
	});
	/*Вид товара в каталоге*/
	KApp.Views.ProductView = Backbone.View.extend({
		tagName: 'tr',
		className: "catalog-item-row",
		template: function (type) {
			var tplId = 'tpl-coffee';
			if (type !== undefined) tplId = 'tpl-' + type;
			if (KApp.Helpers.isMobile()) {
				tplId = tplId + '-mobile';
			}
			return KApp.Helpers.template(tplId);
		},
		events: {
			'click .btn-plus': 'quanUp',
			'click .btn-minus': 'quanDown',
			'change .quan-input': 'setQuan',
			'click .link-more': 'showMore',
			//Для кофе от фермера
			'change .storage-control': 'updateStorage'
		},
		initialize: function () {
			var sklad = $('#skladControls input:checked')
				.val();
			//  this.model.setLimits(sklad);
			this.render();
			this.model.on('change:quantity change:storageCost change:canAddToCart', this.render, this);
			this.model.on('change:filtered', this.setVisibility, this);
		},
		render: function () {
			var tpl = this.template(this.model.get('type'));
			this.$el.html(tpl(this.model.attributes));
			var type = this.model.get('type');
			switch (type) {
			case "farmer-coffee":
				this.initSelects();
				break;
			default:
				break;
			}
			return this;
		},
		changeState: function (itemid) {
			var btnText = this.model.get('lang')
				.inCart;
			if (basketCollection.where({
					id: itemid
				})
				.length > 0) {
				this.set('langDefaults.btnText', btnText);
			}
		},
		// Раскомментировать в случае, если нужно будет в каталоге сделать переключалки количества
		quanUp: function (e) {
			this.model.quanUp();
			return this;
		},
		quanDown: function (e) {
			this.model.quanDown();
			return this;
		},
		setQuan: function (e) {
			this.model.setQuan(e.target.value);
			return this;
		},
		showMore: function (e) {
			e.preventDefault();
			var link = e.currentTarget,
				box = this.el.querySelector(link.getAttribute('href')),
				inClass = 'in',
				activeCLass = 'active';
			if (!this.model.get('needShowMore')) {
				this.model.set('needShowMore', true, {
					silent: true
				});
				link.classList.add(activeCLass);
				box.classList.add(inClass);
				setTimeout(function () {
					box.classList.add(activeCLass);
				}, 30);
			} else {
				link.classList.remove(activeCLass);
				box.classList.remove(activeCLass);
				setTimeout(function () {
					box.classList.remove(inClass);
				}, 350);
				this.model.set('needShowMore', false, {
					silent: true
				});
			}
		},
		setVisibility: function () {
			if (this.model.get('filtered')) this.hide();
			else this.show();
		},
		hide: function () {
			var el = this.el;
			el.classList.add('filtered');
		},
		show: function () {
			var el = this.el;
			el.classList.remove('filtered');
		},
		/*Инициализация селектов*/
		initSelects: function () {
			var $sel = this.$el.find('select');
			$sel.chosen({
				disable_search: true,
				width: '100%'
			});
		},
		/*Изменение срока хранения*/
		updateStorage: function (e) {
			var options = e.target.querySelectorAll('option'),
				storageDuration = options[e.target.selectedIndex].dataset.duration;
			this.model.updateStorage(storageDuration);
		}
	});
	/*Вид каталога (список товаров)*/
	KApp.Views.ProductListView = Backbone.View.extend({
		tagName: 'tbody',
		$alert: $('#product-list-alert'),
		initialize: function () {
			if (this.collection.length) {
				this.render();
			} else {
				this.renderEmpty();
			}
			this.collection.on('add', this.addOne, this);
			this.collection.on('updated', this.render, this);
		},
		render: function () {
			var $pl = $('#productsList');
			this.$el.html('');
			if (this.collection.length) {
				if (this.$alert.length) this.$alert.removeClass('show')
					.css({
						display: 'none'
					});
				$pl.fadeIn(300);
				this.collection.each(function (product) {
					this.$el.append(this.addOne(product));
				}, this);
				$pl.find('tbody')
					.detach();
				// }
				$pl.append(this.$el);
			}
		},
		renderEmpty: function () {
			this.el.innerHTML = '<tr class="catalog-table__info"><td colspan="5">Сейчас товары в этом разделе отсутствуют, попробуйте зайти позже</td></tr>'
			var $pl = $('#productsList');
			$pl.find('tbody')
				.detach();
			$pl.append(this.$el);
		},
		addOne: function (product) {
			// console.log(1,product)

			var p = new KApp.Views.ProductView({
				model: product
			});
			// console.log(2,p)

			return p.render()
				.$el;
		},
		hideProductList: function () {
			var pl = document.getElementById('catalog');
			$(pl)
				.fadeOut(300);
		}
	});
	/*Итоги корзины*/
	KApp.Views.BasketSummaryView = Backbone.View.extend({
		el: '#basket-summary',
		initialize: function () {
			this.model.on('summaryUpdated change:currentStep', this.render, this);
			this.model.on('orderSuccess', this.hide, this);
			this.render();
		},
		render: function () {
			var box = this.el;
			if (this.model.get('quantity')) {
				var tpl = KApp.Helpers.template('tpl-summary');
				this.$el.html(tpl(this.model.attributes));
				KApp.Helpers.showBox(box);
			} else {
				KApp.Helpers.hideBox(box);
			}
			return this;
		},
		hide: function () {
			var box = this.el;
			KApp.Helpers.hideBox(box, 1);
		}
	});
	KApp.Views.BasketSummaryMobieView = Backbone.View.extend({
		el: '#mobile-summary',
		initialize: function () {
			this.model.on('change:mobileSummary', this.update, this);
			this.model.on('change:currentStep', this.updateWp, this);
			this.render();
			this.initWaypoints();
		},
		render: function () {
			var tpl = _.template('<a href="#personal-sidebar" class="btn btn-green btn-fullwidth"><%=mobileSummary%></a>');
			this.el.innerHTML = tpl(this.model.attributes);
			this.initSlowScroll();
		},
		update: function () {
			var link = this.el.querySelector('a');
			link.innerHTML = this.model.get('mobileSummary');
		},
		/* Показ/скрытие мобильного summary (внизу экрана) */
		initWaypoints: function () {
			var order = document.getElementById('personal-sidebar'),
				el = this.el;
			if (order) {
				this.summaryWp = new Waypoint.Inview({
					element: order,
					enter: function (direction) {
						KApp.Helpers.hideBox(el);
					},
					exited: function (direction) {
						if (direction === 'up') {
							KApp.Helpers.showBox(el);
						}
					}
				});
			}
		},
		initSlowScroll: function () {
			var link = this.el.querySelector('a');
			$(link)
				.slowScroll({
					correct: 70
				});
		},
		updateWp: function () {
			Waypoint.refreshAll();
		}
	});
	KApp.Views.OrderBtnView = Backbone.View.extend({
		el: '#order-btn-wrapper',
		initialize: function () {
			this.render();
			this.checkVisibility();
			this.model.on('change:quantity', this.checkVisibility, this);
			this.model.on('change:currentStep change:state', this.render, this);
		},
		events: {
			'click .change-step': 'changeStep',
			'click .make-order': 'makeOrder'
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-order-buttons');
			this.el.innerHTML = tpl(this.model.attributes);
		},
		checkVisibility: function () {
			var box = this.el;
			if (this.model.get('quantity') > 0) {
				KApp.Helpers.showBox(box, 300);
			} else KApp.Helpers.hideBox(box, 300);
		},
		changeStep: function (e) {
			e.preventDefault();
			this.model.set('currentStep', parseInt(e.target.dataset.step));
		},
		makeOrder: function () {
			this.model.trigger('needToMake');
		}
	});
	/*Шкала бесплатной доставки*/
	KApp.Views.ScaleView = Backbone.View.extend({
		el: '#order-scale',
		tpl: 'tpl-order-scale',
		template: function () {
			var tpl = 'tpl-order-scale'; //шаблон шкалы по умолчанию
			if (this.model.get('cargoLimits')) tpl = 'tpl-cargo-scale';
			return KApp.Helpers.template(tpl);
		},
		initialize: function () {
			this.render();
			this.model.on('freeDeliveryUpdated change:needRoast cargoLimitsUpdated', this.render, this);
		},
		render: function () {
			var tpl = this.template();
			this.$el.html(tpl(this.model.attributes));
			return this;
		}
	});
	/*Вид товара в корзине*/
	KApp.Views.BasketItemView = Backbone.View.extend({
		tagName: 'tr',
		className: 'basket-item',
		events: {
			'click .btn-delete-item': 'removeFromBasket',
			'change .roast-flag': 'setRoast'
		},
		template: function (type) {
			var tplId = 'basket-item-tpl';
			switch (type) {
			case 'coffee':
				tplId = 'basket-item-tpl-coffee';
				break;
			case 'probe':
				tplId = 'basket-item-tpl-probe';
				break;
			default:
				tplId = 'basket-item-tpl';
				break;
			}
			return KApp.Helpers.template(tplId);
		},
		initialize: function () {
			this.model.on('change', this.model.calc);
			this.model.on('change', this.render, this);
			this.model.on('outBasket', this.removeFromBasket, this);
			this.render();
		},
		render: function () {
			var tpl = this.template(this.model.get('type'));
			this.$el.html(tpl(this.model.attributes));
			return this;
		},
		setQuan: function (e) {
			this.model.setQuan(e.target.value);
			return this;
		},
		quanUp: function (e) {
			this.model.quanUp(e);
			return this;
		},
		quanDown: function (e) {
			this.model.quanDown(e);
			if (this.model.get('quantity') === 0) {
				if (confirm(this.model.get('lang')
						.removeConfirm)) this.destroy();
				else this.quanUp();
			}
			return this;
		},
		removeFromBasket: function () {
			if (this.model.collection) {
				this.model.collection.remove(this.model);
			}
			this.undelegateEvents();
			this.$el.remove();
		},
		setRoast: function (e) {
			this.model.set('roastFlag', e.target.checked, {
				silent: true
			});
			this.model.trigger('roastChanged');
		}
	});
	/* Вид корзины */
	KApp.Views.BasketView = Backbone.View.extend({
		tagName: 'tbody',
		store: '2',
		$wrapper: $('.order-results'),
		datepickerEl: '#datepicker',
		$datepickerEl: '',
		initialize: function () {
			this.render();
			this.collection.on('change updated remove reset', this.render, this);
			this.collection.on('change remove', this.collection.setStorage);
			this.collection.on('change', KApp.Helpers.basketIndicators);
			this.sklad = $("#skladControls input:checked")
				.val();
		},
		render: function () {
			var $bi = $('#basketItems');
			this.$el.html('');
			if (this.collection.length > 0) {
				this.collection.each(function (product) {
					this.$el.append(this.addOne(product));
				}, this);
			} else {
				var tr = document.createElement('tr'),
					td = document.createElement('td');
				tr.classList.add('empty-basket');
				tr.id = 'empty-basket';
				tr.innerHTML = '<td><span class="text-info">Ваша корзина пока пуста. Добавьте товары из каталога слева</span></td>';
				this.el.appendChild(tr);
			}
			$bi.find('tbody')
				.detach();
			$bi.html(this.$el);
			return this;
		},
		addOne: function (product) {
			var p = new KApp.Views.BasketItemView({
				model: product
			});
			return p.render()
				.$el;
		}
	});
	/*Список плательщиков*/
	KApp.Views.PayersList = Backbone.View.extend({
		tagName: 'select',
		events: {
			'click .payer-radio': 'showNotify',
			'click option': 'updatePayer',
		},
		initialize: function () {
			this.wrapper = document.getElementById('payers-list');
			if (this.wrapper) this.render();
		},
		render: function () {
			this.collection.each(this.renderOne, this);
			this.wrapper.appendChild(this.el);
			this.$el.chosen({
					width: '100%',
					disable_search_threshold: 10
				})
				.change(function (e, data) {
					this.collection.changePayer(e.target.value);
				}.bind(this));
			return this;
		},
		renderOne: function (model) {
			var option = document.createElement('option');
			option.value = model.get('id');
			option.innerHTML = model.get('name');
			if (model.get('selected')) option.setAttribute('selected', 'true');
			this.el.appendChild(option);
		}
	});
	/*Вид товара на этапе подтверждения заказа*/
	KApp.Views.ItemConfirmView = Backbone.View.extend({
		tagName: 'tr',
		className: 'catalog-item-row',
		initialize: function () {
			this.render();
		},
		render: function () {
			var tpl = KApp.Helpers.template('basket-confirm-tpl');
			this.$el.html(tpl(this.model.attributes));
		}
	});
	/*Вид списка товаров на этапе подтверждения заказа*/
	KApp.Views.BasketConfirmView = Backbone.View.extend({
		tagName: 'tbody',
		initialize: function () {
			this.render();
		},
		render: function () {
			this.collection.each(this.addOne, this);
		},
		addOne: function (item, i) {
			var iterator = i + 1;
			item.set('iterator', iterator);
			var basketItem = new KApp.Views.ItemConfirmView({
				model: item
			});
			this.$el.append(basketItem.$el);
		}
	});
	KApp.Views.Alert = Backbone.View.extend({
		duration: 3000,
		initialize: function () {
			this.render();
		},
		render: function () {
			var tpl = KApp.Helpers.template('alert-tpl');
			this.el.innerHTML = tpl(this.model.attributes);
			if (typeof this.duration === 'number') {
				setTimeout(this.destroy.bind(this), this.duration);
			}
			this.$el.fadeIn(200);
		},
		destroy: function () {
			var $alert = this.$el;
			$alert.fadeOut(200)
				.queue(function () {
					$alert.html('');
					$(this)
						.dequeue();
				});
		}
	});
	KApp.Views.Modal = Backbone.View.extend({
		tagName: 'div',
		className: 'wf-popup',
		id: 'modalWindow',
		initialize: function () {
			this.render();
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-modal');
			this.el.classList.add(this.model.get('sizeClass'));
			this.el.innerHTML = tpl(this.model.attributes);
			this.open();
		},
		open: function () {
			var $popup = this.$el;
			var view = this;
			$.magnificPopup.open({
				items: {
					src: $popup,
					type: 'inline'
				},
				callbacks: {
					beforeClose: function () {
						view.close();
					},
				}
			});
		},
		close: function () {
			this.undelegateEvents();
			this.remove();
		}
	});
	/*Попап с подтверждением действия*/
	KApp.Views.ConfirmModal = Backbone.View.extend({
		tagName: 'div',
		className: 'wf-popup',
		events: {
			"click .btn-ok": "confirmCallback",
			"click .btn-no": "closeModal"
		},
		initialize: function () {
			this.render();
			this.open();
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-confirm-modal');
			this.el.innerHTML = tpl(this.model.attributes);
			this.el.classList.add(this.model.get('sizeClass'));
		},
		open: function () {
			var $popup = this.$el;
			var view = this;
			$.magnificPopup.open({
				items: {
					src: $popup,
					type: 'inline'
				},
				callbacks: {
					beforeClose: function () {
						view.close();
					},
				}
			});
		},
		confirmCallback: function () {
			this.model.confirmCallback();
		},
		closeModal: function () {
			$.magnificPopup.close();
		},
		close: function () {
			this.undelegateEvents();
			this.remove();
		}
	});
	KApp.Views.StoreNavBtnView = Backbone.View.extend({
		tagName: 'li',
		className: 'nav-item',
		initialize: function () {
			this.render();
			this.model.on('change', this.render, this);
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-store-nav-btn');
			this.$el.html(tpl(this.model.attributes));
		},
		events: {
			'click .nav-link': 'selectItem'
		},
		selectItem: function () {
			var storeId = this.model.get('id');
			this.model.collection.selectStore(storeId);
		}
	});
	KApp.Views.StoreNavView = Backbone.View.extend({
		tagName: 'ul',
		className: 'list-inline',
		el: '',
		initialize: function () {
			this.wrapper = $('#skladControls');
			this.render();
			this.collection.on('change', this.changeStore, this);
		},
		render: function () {
			this.collection.each(this.renderOne, this);
			this.wrapper.html(this.$el);
		},
		renderOne: function (model) {
			var item = new KApp.Views.StoreNavBtnView({
				model: model
			});
			this.$el.append(item.$el);
		},
		changeStore: function (current) {
			$('#store-unit')
				.text(current.get('unit'));
		}
	});
	/*Карточка варианта доставки*/
	KApp.Views.DeliveryBtnView = Backbone.View.extend({
		tagName: 'div',
		className: 'col-12',
		initialize: function () {
			this.render();
			this.model.on('change', this.render, this);
		},
		render: function () {
			this.model.attributes.type == "external" ? this.model.attributes.description = window.selectedPayer.address : "Адрес"
			var tpl = KApp.Helpers.template('tpl-delivery-nav-btn');
			this.$el.html(tpl(this.model.attributes));
		},
		events: {
			'click .delivery-card:not(.inactive)': 'selectItem'
		},
		selectItem: function () {
			this.model.collection.selectDelivery(this.model.cid);
		}
	});
	/*Переключатель вариантов доставки в заказе*/
	KApp.Views.DeliveryListView = Backbone.View.extend({
		tagName: 'div',
		className: 'row delivery-list',
		initialize: function () {},
		render: function () {
			this.collection.each(this.renderOne, this);
		},
		renderOne: function (model) {
			var item = new KApp.Views.DeliveryBtnView({
				model: model
			});
			this.$el.append(item.$el);
		}
	});
	/*Форма данных для доставки*/
	KApp.Views.DeliveryFormView = Backbone.View.extend({
		el: '#delivery-form-wrapper',
		className: 'delivery-form',
		initialize: function () {
			this.showState = false;
			this.render();
			this.model.on('change:delivery', this.toggle, this);
			//не трогать, переполняет стэк
			// this.model.on('success change:endpoint', this.render, this);
			this.model.on('needToShow', this.show, this);
			this.model.on('needToHide', this.hide, this);
			this.model.on('change:errorsBuffer', this.validate, this);
			this.model.once('change:errorsBuffer', this.enableBlurValidation, this);
		},
		events: {
			'input .delivery-input': 'setValueToModel',
			'blur .delivery-input': 'setValueToModel',
			'change .endpoint': 'updateEndpoint'
		},
		render: function (ep = "moscow") {
			var tpl = KApp.Helpers.template('tpl-delivery-form');
			var userData = this.model.get('userDeliveryData');
			let deliveryVariantsObj = {
				deliveryVariants: this.model.attributes.deliveryVariants.models
			}
			let deliveryObj = {
				delivery: this.model.attributes.delivery
			}
			let summary = Object.assign(userData.attributes, deliveryObj);
			summary.endpoint = ep;
			// console.log(summary);
			this.$el.html(tpl(summary));
			this.setAnimatedInputs();
		},
		initHeight: function () {
			this.formHeight = this.el.querySelector('.delivery-form__inner')
				.clientHeight;
			this.el.style.height = 0;
		},
		toggle: function (model, data) {
			if (data.type === 'shipping') {
				KApp.Helpers.showBox(this.el);
			} else {
				KApp.Helpers.hideBox(this.el);
			}
		},
		show: function () {
			if (typeof this.formHeight === "undefined") this.initHeight();
			var form = this.el,
				height = this.formHeight;
			this.el.classList.add('show');
			anime({
				targets: form,
				height: height,
				duration: 500,
				easing: 'easeOutQuad'
			});
		},
		hide: function () {
			var form = this.el,
				heightArr = [this.formHeight, 0];
			anime({
				targets: form,
				height: heightArr,
				duration: 500,
				easing: 'easeOutQuad',
				complete: function () {
					form.classList.remove('show');
				}
			});
		},
		setAnimatedInputs: function () {
			var inputs = this.$el.find('.form-row--animated input');
			_.map(inputs, function (input) {
				setAnimatedInput(input);
				input.addEventListener('blur', function () {
					setAnimatedInput(this);
				});
			});
		},
		enableBlurValidation: function () {
			var inputs = this.el.querySelectorAll('input'),
				view = this;
			_.map(inputs, function (input) {
				input.addEventListener('blur', function () {
					view.model.markErrors();
					view.validateOne(input);
				});
			});
		},
		validate: function () {
			var inputs = this.el.querySelectorAll('input');
			_.map(inputs, this.validateOne, this);
		},
		validateOne: function (input) {
			if (typeof input === "undefined") return false;
			var errors = this.model.get('errorsBuffer'),
				name = input.name;
			if (_.indexOf(errors, name) < 0) input.classList.remove('error');
			else input.classList.add('error');
			return this;
		},
		setMaskedInputs: function () {
			var $masks = this.$el.find('[data-mask]'),
				model = this.model;
			$masks.each(function () {
				var $field = $(this);
				var mask = $field.data('mask'),
					field = this.name;
				$(this)
					.mask(mask, {
						completed: function () {
							model.set(field, this.val());
							$field.trigger('change');
						}
					});
				$(this)
					.on('blur', function (e) {
						var input = this;
						setTimeout(function () {
							setAnimatedInput(input);
						}, 150);
					});
			});
		},
		setValueToModel: function (e) {
			var userDeliveryData = this.model.get('userDeliveryData');
			var val = e.currentTarget.value,
				name = e.currentTarget.getAttribute('name');
			userDeliveryData.set(name, val);
		},
		updateEndpoint: function (e) {
			var ep = e.target.value;
			this.model.set('endpoint', ep);
			this.model.get("userDeliveryData")
				.set('endpoint', ep)
		}
	});
	KApp.Views.OrderResultsView = Backbone.View.extend({
		el: '#order-final',
		initialize: function () {
			this.render();
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-order-results');
			this.el.innerHTML = tpl(this.model.attributes);
		}
	});
	/*Фильтр - полный*/
	KApp.Views.CatalogFiltersView = Backbone.View.extend({
		el: '#catalog-filters',
		initialize: function () {
			this.render();
		},
		render: function () {
			this.collection.each(this.renderOne, this);
		},
		renderOne: function (model) {
			var filterItem = new KApp.Views.CatalogFilterItem({
				model: model
			});
			this.el.appendChild(filterItem.el);
		}
	});
	/*Фильтр - Элемент*/
	KApp.Views.CatalogFilterItem = Backbone.View.extend({
		tagName: 'div',
		className: 'col-6',
		initialize: function () {
			this.render();
		},
		template: function (type) {},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-filter-item');
			this.el.innerHTML = tpl(this.model.attributes);
			this.setFieldsSize();
			this.renderField();
		},
		/*Рендеринг полей фильтра (инпуты/селекты и т.д.)*/
		renderField: function () {
			var type = this.model.get('type');
			var clientId = this.model.get('clientId');
			var wrapper = this.el.querySelector('#' + clientId);
			switch (type) {
			case 'select':
				var items = this.model.get('values');
				var view = new KApp.Views.SelectFilterControl({
						collection: items
					}),
					$select = view.$el;
				wrapper.classList.add('select-bordered');
				wrapper.classList.add('select-md');
				wrapper.appendChild(view.el);
				view.initChosen();
				break;
			case 'input':
				var view = new KApp.Views.InputFilterControl({
					model: this.model
				});
				wrapper.classList.add('filter-item--search');
				wrapper.appendChild(view.el);
				break;
			default:
				break;
			}
		},
		setFieldsSize: function () {
			var size = this.model.get('size'),
				sizeClass = 'col-md-6';
			if (size === 'small') sizeClass = 'col-md-4';
			if (size === 'large') sizeClass = 'col-md-8';
			if (typeof size !== 'undefined') this.el.classList.add(sizeClass);
		}
	});
	/*Контрол-селект*/
	KApp.Views.SelectFilterControl = Backbone.View.extend({
		tagName: 'select',
		events: {
			'click option': 'updateSelected'
		},
		initialize: function () {
			this.render();
		},
		render: function () {
			this.collection.each(this.renderOne, this);
			return this;
		},
		renderOne: function (model) {
			var option = document.createElement('option');
			option.value = model.get('id');
			option.innerHTML = model.get('name');
			if (model.get('selected')) option.setAttribute('selected', 'true');
			this.el.appendChild(option);
		},
		initChosen: function () {
			this.$el.chosen({
					width: '100%',
					disable_search_threshold: 10
				})
				.change(function (e, data) {
					var value = e.target.value;
					this.collection.updateSelected(value);
				}.bind(this))
		}
	});
	KApp.Views.InputFilterControl = Backbone.View.extend({
		tagName: 'input',
		className: 'input-basic theme-new-gray input-md',
		initialize: function () {
			this.render();
			var model = this.model;
			var throttleUpdate = function (e) {
				model.set('value', e.target.value);
			}
			this.el.addEventListener('input', _.throttle(throttleUpdate, 500, false));
		},
		render: function () {
			if (typeof this.model.get('value') !== 'undefined') this.el.value = this.model.get('value');
			if (typeof this.model.get('caption') !== "undefined") this.el.placeholder = this.model.get('caption');
			return this;
		}
	});
	KApp.Views.StorageCalendarView = Backbone.View.extend({
		el: '#storage-calendar',
		initialize: function () {
			this.model.on('showStorageCalendar', this.render, this);
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-storage-calendar');
			this.el.innerHTML = tpl(this.model.attributes);
			this.hideOldContent();
			//this.renderItems();
			this.navToTop();
		},
		renderItems: function () {
			var items = this.model.get('items');
			var filteredItems = items.getOnlyStorageItems();
			var itemsCollection = new KApp.Collections.BasketCollection(filteredItems);
			var view = new KApp.Views.StorageCalendarItemsListView({
				collection: itemsCollection
			});
		},
		hideOldContent: function () {
			this.toggleHeading();
			this.model.trigger('plNeedToHide'); // скрытие списка товаров
		},
		toggleHeading: function () {
			var newHeadingStr = 'План отгрузок по месяцам';
			var heading = document.getElementById('order-heading');
			if (heading) heading.innerHTML = newHeadingStr;
		},
		/*Прокрутка к началу страницы*/
		navToTop: function () {
			var timeout = 1;
			var pageTop = document.getElementById('page-top');
			if (pageTop) {
				if (KApp.Helpers.isMobile()) timeout = 3000;
				setTimeout(function () {
					pageTop.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					})
				}, timeout);
			}
		}
	});
	KApp.Views.StorageCalendarItemsListView = Backbone.View.extend({
		el: '#storage-calendar-items',
		initialize: function () {
			this.render();
		},
		render: function () {
			this.collection.each(this.renderOne, this);
		},
		renderOne: function (model) {
			var item = new KApp.Views.StorageCalendarItemView({
				model: model
			});
			this.el.appendChild(item.el);
		}
	});
	KApp.Views.StorageCalendarItemView = Backbone.View.extend({
		tagName: 'div',
		className: 'storage-item',
		initialize: function () {
			this.render();
		},
		render: function () {
			var tpl = new KApp.Helpers.template('tpl-storage-item');
			this.el.innerHTML = tpl(this.model.attributes);
			if (typeof ARRIVE_MONTH !== 'undefined') this.renderMonths(); //рендерим месяцы
		},
		renderMonths: function () {
			var timing = this.model.getStorageTiming();
			_.map(timing, function (data) {
				this.renderMonthItem(data);
			}.bind(this));
		},
		renderMonthItem: function (data) {
			var mId = '#months-' + this.model.get('id');
			var monthsWrapper = this.el.querySelector(mId);
			var monthModel = new Backbone.Model(data);
			var monthView = new KApp.Views.StorageMonthView({
				el: monthsWrapper,
				model: monthModel
			});
		}
	});
	KApp.Views.StorageMonthView = Backbone.View.extend({
		initialize: function () {
			this.render();
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-storage-month');
			var item = tpl(this.model.attributes);
			this.$el.append(item);
		}
	});
	KApp.Views.HeaderBalanceView = Backbone.View.extend({
		el: '#header-balance',
		initialize: function () {
			if (this.el) {
				this.initStartBalance();
				this.model.on('change:balance', this.update, this);
			}
		},
		/* Сохраняем в модель стартовое значение из HTML */
		initStartBalance: function () {
			var currentBalance = parseInt(this.el.innerText, 10);
			if (!isNaN(currentBalance)) {
				this.model.set('balance', currentBalance, {
					silent: true
				});
			}
		},
		update: function (model, newBalance) {
			var currentBalance = parseInt(newBalance, 10);
			var prevBalance = parseInt(model._previousAttributes.balance, 10);
			if (!isNaN(prevBalance) && prevBalance !== currentBalance) {
				var balanceBox = this.el;
				var balanceObj = {
					balance: prevBalance
				}
				anime({
					targets: balanceObj,
					balance: newBalance,
					round: 1,
					easing: 'easeInOutExpo',
					duration: 500,
					update: function () {
						balanceBox.innerHTML = balanceObj.balance;
					}
				});
			}
		}
	})
});
var basketCollection, //товары в корзине
	productsCollection, //товары в корзине
	basketName, //имя текущей корзины
	basketView, //отображение корзины
	payersCollection; //список плательщиков
var errorsLog = []; //сюда сохраняются ошибки
$(function () {
	var productList = []; //инициализируем пустой список товаров
	if (typeof products !== "undefined") {
		_.map(products, function (product) {
			productList.push(product)
		})
	}
	productsCollection = new KApp.Collections.ProductsCollection(productList);
	var initialOrderData = {};
	/*Варианты доставки*/
	if (typeof DELIVERIES !== "undefined") initialOrderData.deliveryVariants = new KApp.Collections.DeliveryCollection(DELIVERIES);
	if (typeof CURRENT_STORE !== "undefined") initialOrderData.store = CURRENT_STORE;
	if (typeof CARGO_LIMITS !== "undefined") initialOrderData.cargoLimits = CARGO_LIMITS;
	if (typeof ORG_SEARCH_URL !== "undefined") {
		var searchModel = new OrgSearch.Models.SearchModel(); //поиск по плательщикам
		initialOrderData.orgSearch = searchModel;
	}
	var ORDER = new KApp.Models.OrderModel(initialOrderData);
	//Если контейнер переполнен, запрещаем добавлять товары
	productsCollection.listenTo(ORDER, 'change:cargoLimitOver', productsCollection.controlLimits);
	if (typeof CARGO_LIMITS !== "undefined") {
		var storageCalendarView = new KApp.Views.StorageCalendarView({
			model: ORDER
		});
	}
	if (typeof payers !== 'undefined') {
		//Синхронизируем список продуктов с корзиной
		productsCollection.listenTo(ORDER, 'itemsUpdated itemsLoaded basketItemRemoved', productsCollection.syncQuantities);
		//Фильтрация каталога
		if (typeof SHOW_FILTERS !== "undefined" && typeof FILTERS_LIST !== "undefined" && SHOW_FILTERS && FILTERS_LIST.length) {
			var filters = productsCollection.getFiltersData(FILTERS_LIST);
			var filtersCollection = new KApp.Collections.FiltersCollection(filters);
			var filtersView = new KApp.Views.CatalogFiltersView({
				collection: filtersCollection
			});
			productsCollection.listenTo(filtersCollection, 'filterUpdated', productsCollection.filterCollection);
		}
		ORDER.initBasket(); //инициализация корзины
		ORDER.listenTo(productsCollection, 'changeQuantity changeStorage', ORDER.updateBasketItem); //добавление в корзину
		//Офомление заказа
		var checkoutView = new KApp.Views.CheckoutView({
			model: ORDER
		});
		// Список товаров
		if (document.getElementById('productsList') !== null) {
			var productsView = new KApp.Views.ProductListView({
				collection: productsCollection
			}); //список товаров
			productsView.listenTo(ORDER, 'plNeedToHide', productsView.hideProductList);
		}
		/* Баланс в шапке */
		var balanceModel = new KApp.Models.BalanceModel();
		var balanceView = new KApp.Views.HeaderBalanceView({
			model: balanceModel
		});
		balanceModel.listenTo(ORDER, 'orderSuccess', balanceModel.updateBalance)
	}
	if (typeof BASKET_COOKIE !== "undefined") store.removeExpiredKeys();
});
window.BookingApp = {
	Models: {},
	Collections: {},
	Views: {},
	Helpers: {
		validate: function (curr) {
			return (this.isNoHoliday(curr) && this.isNoWeekend(curr) && this.isNoPast(curr));
		},
		isNoHoliday: function (curr) {
			var formatted = curr.format("YYYY/MM/DD"),
				index = _.indexOf(holydays, formatted) + 1;
			return (index < 1);
		},
		isNoWeekend: function (curr) {
			var dow = parseInt(curr.format("d"));
			return (dow !== 0 && dow !== 6);
		},
		isNoPast: function (curr) {
			var date = moment()
				.subtract(1, "day");
			return moment(date)
				.isSameOrBefore(curr);
		},
		/*Приводим массив с бронированием в форму, пригодную для дальнейшей работы*/
		modifyHoursList: function (hours) {
			var modified = [];
			_.map(hours, function (booking, hour) {
				var reserved = !!booking;
				var curr = {
					value: hour,
					reserved: reserved,
				};
				modified.push(curr);
			});
			return modified;
		},
		selectDay: function (day) {
			var selector = ".calendar-day-" + day,
				$cldr = $(".clndr"),
				$oldSelected = $cldr.find(".selected"),
				$newSelected = $cldr.find(selector);
			$oldSelected.removeClass("selected");
			$newSelected.addClass("selected");
		},
		prepareCalendar: function (clndr) {
			var arrDays = [];
			_.map(clndr, function (params, date) {
				var split = date.split("."),
					dateFormatted = split[2] + "-" + split[1] + "-" + split[0],
					hours = [],
					dow = moment(dateFormatted)
					.format("d"),
					dayOfMonth = moment(dateFormatted)
					.date(),
					unixTime = moment(dateFormatted)
					.unix(),
					activeClass = "calendar-day-holiday",
					month = moment(dateFormatted)
					.month();
				if (params.WORK === true) {
					hours = BookingApp.Helpers.modifyHoursList(params.HOURS);
					activeClass = "active-day"
				}
				var day = {
					date: date,
					dateFormatted: dateFormatted,
					month: month,
					dow: dow,
					dom: dayOfMonth,
					unixTime: unixTime,
					work: params.WORK,
					hours: hours,
					activeClass: activeClass,
				};
				arrDays.push(day);
			});
			var sortedDays = _.sortBy(arrDays, "unixTime");
			return sortedDays;
		},
		/**prepareClndrByMonths - готовит массив дат с разбивкой на месяцы
		 * @param {object} clndr - массив дат, не разделённых на месяцы
		 * */
		prepareClndrByMonths: function (clndr) {
			var monthsArr = _.groupBy(clndr, "month"),
				monthskeys = _.keys(monthsArr),
				isJanuary = false;
			if (monthskeys[0] == 0 && monthskeys[1] == 11) isJanuary = true;
			var finalMontsArr = [];
			_.map(monthsArr, function (days, month, i) {
				var monthStr = moment()
					.month(month)
					.format("MMMM");
				var monthObj = {
					month: month,
					monthStr: monthStr,
					days: days,
					active: false,
				};
				finalMontsArr.push(monthObj);
			}, this);
			if (isJanuary) { //если январь, то переносим январь в конец массива
				var lastMonth = finalMontsArr[0];
				finalMontsArr[0] = finalMontsArr[1];
				finalMontsArr[1] = lastMonth;
			}
			finalMontsArr[0].active = true;
			return finalMontsArr;
		},
	},
}
BookingApp.Models.DayModel = Backbone.Model.extend({
	defaults: {
		date: "",
		dateCompact: "00",
		work: false,
		hours: [],
		activeClass: "calendar-day-holiday",
	},
});
/**Модель аренды ростера.
 * Данные, передающиеся в заказ на сервер
 * @param {date} date - дата бронирования в формате
 * @param {number} orderId - id связанного заказа кофе,
 * @param {array} hours - массив с выбраннными часами, прим - [12,13,14]
 * @param {object} roaster - данные о выбранном ростере
 * @param {object} payer - данные о выбранном плательщике
 * @param {number} roastQuantity - количество товара (для подсчета стоимости бронирования при заказе кофе)
 * Данные для отображения в публичной части (вспомогательные)
 * @param {string} price - вычисленная цена аренды
 * @param {string} interval - промежуток в формате c xx:00 - yy:59 - интервал аренды
 * @param {number} currentStep
 * */
BookingApp.Models.BookingModel = Backbone.Model.extend({
	defaults: {
		date: "", //дата брони
		hours: "", //все часы
		selectedHours: [], //выбранные  пользователем часы брони
		interval: "", //интервал (для отображения)
		duration: "", //продолжительность
		price: "", //стоимость
		roastQuantity: "", //количество
		payer: "", //выбранный плательщик
		orderId: "", //id заказа (если это бронь из заказа кофе)
		roaster: "", //выбранный ростер
		roastersList: [], //список ростеров
		currentStep: 0, //текущий шаг
	},
	initialize: function () {
		this.initRoasters();
		this.initPayers();
		var hours = this.get("hours");
		hours.on("change", this.setBookingHours, this);
		this.on("changeHours change:roaster", this.calculate, this);
	},
	/*Инициализация ростеров*/
	initRoasters: function () {
		var roastersList = this.get("roastersList");
		roastersList.on("updateSelected", this.updateRoaster, this);
		roastersList.initSelected(); //пробрасываем первоначально выбранный ростер в модель заказа
	},
	/*Инициализация плательщиков*/
	initPayers: function () {
		var payersList = this.get("payersList");
		var selectedPayer = payersList.findWhere({
			"selected": true
		});
		if (typeof selectedPayer == "undefined") selectedPayer = payersList.at(0);
		this.set("payer", selectedPayer.attributes);
		payersList.on("change", this.updatePayer, this);
	},
	/**Подсчёт стоимости бронирования.
	 * Если явно указано количество товара roastQuantity, то считаем стоимость по схеме кол-во товара * цена за единицу.
	 * Если количество товара не задано, считаем стоимость по схеме цена часа * количество часов.
	 * */
	calculate: function () {
		var ruMoneyFormat = wNumb({
			thousand: " ",
			suffix: " ₽",
		});
		var selectedHours = this.get("selectedHours");
		var cost = this.get("roaster")
			.price,
			quantity = this.get("roastQuantity"),
			priceFormatted = "";
		if (cost === undefined) cost = 0;
		if (selectedHours === undefined) selectedHours = [];
		if (quantity === "") //если не задано количество килограм, считаем итоговую цену по часам
			quantity = selectedHours.length;
		if (cost && quantity) priceFormatted = ruMoneyFormat.to(cost * quantity);
		this.set("price", priceFormatted);
	},
	/**Обновление данных о плательщике*/
	updatePayer: function (payer) {
		var newpayer = payer.collection.getSelectedPayer();
		if (newpayer) this.set("payer", newpayer);
	},
	/**Обновление даты бронирования*/
	setBookingDate: function (day) {
		this.clearOrder(); //данные
		var date = day.get("date"),
			hours = day.get("hours"), //новая коллекция часов
			currHours = this.get("hours"); // текущая коллекция часов
		currHours.reset(hours); //наполняем текущую коллекцию новыми значениями
		this.set("date", date);
	},
	/**Обновление данных о времени брони*/
	setBookingHours: function (hours) {
		var hours = this.get("hours"),
			selectedHours = hours.getSelectedHours();
		var interval = "";
		if (selectedHours.length > 0) interval = selectedHours[0] + ":00" + "-" + selectedHours[selectedHours.length - 1] + ":59";
		this.set("selectedHours", selectedHours);
		this.set("interval", interval);
		this.trigger("changeHours");
	},
	clearOrder: function () {
		var fields = ["date", "price", "interval"];
		_.map(fields, function (field) {
			this.set(field, "");
		}, this);
	},
	checkOrder: function () {
		var data = this.attributes,
			checkMessage = "";
		if (data.roaster === "") checkMessage += "Выберите ростер. ";
		if (data.date === "") checkMessage += "Выберите день бронирования. ";
		if (data.hours.length === 0) checkMessage += "Выберите хотя бы один час бронирования. ";
		if (data.payer === "") checkMessage += "Укажите плательщика.";
		var result = {};
		result.success = (data.hours.length > 0 && data.payer !== "" && data.roaster !== "");
		result.text = checkMessage;
		return result;
	},
	/**Проверка ограничений на минимальный заказ времени*/
	checkLimits: function () {
		var selected = this.get("hours");
		var limit = parseInt(CLNDR_LIMIT);
		return (limit === selected.length);
	},
	/*Возвращает данные для отправки*/
	getOrderData: function () {
		var data = this.attributes;
		var sessid = BX.bitrix_sessid();
		var orderData = {
			date: data.date,
			hours: data.selectedHours,
			payer: data.payer,
			roasterId: data.roaster.id,
		};
		if (data.orderId !== "") orderData.orderId = data.orderId;
		if (data.orgSearch) {
			var user_org = data.orgSearch.get("selectedId");
			if (user_org !== "") {
				orderData.user_org = user_org;
			}
		}
		return orderData;
	},
	sendOrder: function () {
		var order = this,
			sessid = BX.bitrix_sessid(),
			orderData = this.getOrderData();
		$.ajax({
			url: BOOKING_URL,
			method: "post",
			data: {
				sessid: sessid,
				jsonData: JSON.stringify(orderData),
			},
			success: function (res) {
				if (res.success) {
					order.clearOrder();
					order.trigger("successBooking");
					var data = {
						status: res.status,
						title: "Ошибка",
						message: res.message,
					};
					if (res.success) {
						data.status = "success";
						data.title = "Ваш Заказ успешно создан.";
						data.message = res.message;
					}
					data.orderId = res.orderId || "";
					order.set("currentStep", 1);
					order.trigger("orderSuccess", data);
					//Если бронируем обжарку из заказа
					if (orderData.orderId) {
						setTimeout(function () {
							location.reload();
						}, 3300);
					}
				} else {
					KApp.Helpers.showNotify({
						type: "warning",
						text: res.message,
					}, 2000, "#order-alerts");
				}
			},
			error: function (err) {
				console.log("error", err);
			},
		});
	},
	updateRoaster: function (data) {
		this.set("roaster", data);
	},
});
BookingApp.Models.HourModel = Backbone.Model.extend({
	defaults: {
		value: "09",
		reserved: false,
		selected: false,
		blocked: false,
	},
	toggleSelect: function () {
		var curr = this.get("selected");
		var checkContinuity;
		if (curr === false) {
			checkContinuity = this.collection.checkContinuityOnSelect(this);
			if (checkContinuity) {
				this.set("selected", !curr);
			} else {
				KApp.Helpers.showNotify({
					type: "warning",
					text: "Интервал бронирования должен быть непрерывным",
				}, 2000, "#booking-hours-errors");
			}
		} else {
			this.collection.controlContinuity(this);
		}
	},
});
/*Модель ростера*/
BookingApp.Models.RoasterModel = Backbone.Model.extend({
	defaults: {
		id: "0",
		title: "Тестовый ростер",
		price: "1100",
		disabled: false,
		selected: false,
	},
});
BookingApp.Models.MonthModel = Backbone.Model.extend({
	defaults: {
		month: 0,
		monthStr: "",
		days: [],
	},
});
/*Коллекция календаря (набор дней)*/
BookingApp.Collections.CalendarCollection = Backbone.Collection.extend({
	model: BookingApp.Models.DayModel,
	orderProps: {
		date: '',
		hours: '',
		interval: '',
		price: '',
		valid: false,
		payer: '',
		prepared: false
	},
	initialize: function () {
		this.on('selected', this.selectedDay, this);
		// this.on('reset', this.prepareCalendar, this);
	},
	prepareCalendar: function () {
		// if (!this.orderProps.prepared) {
		this.prepareTodayHours(); //делаем невозможным заказ прошедших чисел сегодняшнего дня.
		var startDay = this.models[0].get('dateFormatted'),
			endDay = this.models[this.models.length - 1].get('dateFormatted'),
			startDate = moment(startDay)
			.date(),
			endDate = moment(endDay)
			.date();
		this.prependDays(startDate);
		this.appendDays(endDate);
		this.orderProps.prepared = true;
		//  }
	},
	prepareTodayHours: function () {
		var today = this.at(0),
			hours = today.get('hours'),
			currentHour = moment()
			.hour();
		_.map(hours, function (hour) {
			if (parseInt(hour.value) <= currentHour) hour.reserved = true;
		});
	},
	prependDays: function (start) { //добавляем дни в колекцию спереди до начала недели
		var day = this.models[0],
			date = moment(day)
			.date(),
			firstDow = parseInt(day.get('dow'));
		if (start > 1) { //дорисовываем дни до начала месяца
			var firstDate = this.models[0].get('dateFormatted'),
				prevDate = moment(firstDate)
				.subtract(1, 'days');
			do {
				this.unshift(new BookingApp.Models.DayModel({
					date: prevDate.format('DD.MM.YYYY'),
					dateCompact: moment(prevDate)
						.format('DD.MM'),
					work: false,
					inactive: true,
					dow: prevDate.format('d'),
					activeClass: 'past'
				}));
				firstDow = prevDate.day();
				date--;
				prevDate = moment(prevDate)
					.subtract(1, 'days');
			} while (date > 1);
		}
		if (firstDow === 0) //если первое число выпадает на воскресенье
			firstDow = 7; //устанавливаем 7, чтобы впоследствии дорисовались шесть предыдущих дней недели
		if (firstDow > 1) { //дорисовываем дни до начала недели
			var firstDate = this.models[0].get('dateFormatted'),
				prevDate = moment(firstDate)
				.subtract(1, 'days');
			do {
				this.unshift(new BookingApp.Models.DayModel({
					date: prevDate.format('DD.MM.YYYY'),
					dateCompact: moment(prevDate)
						.format('DD.MM'),
					work: false,
					inactive: true,
					dow: prevDate.format('d'),
					activeClass: 'past prev-month'
				}));
				firstDow--;
				prevDate = moment(prevDate)
					.subtract(1, 'days');
			} while (firstDow > 1);
		}
	},
	appendDays: function (end) {
		var day = this.models[this.models.length - 1],
			dateFormatted = day.get('dateFormatted'),
			date = moment(day)
			.date(), //дата последнего месяца
			dim = moment(dateFormatted)
			.daysInMonth(day); //кол-во дней в месяце
		if (end < dim) {
			var lastDate = this.models[this.models.length - 1].get('dateFormatted'),
				nextDate = moment(lastDate)
				.add(1, 'days');
			do {
				this.push(new BookingApp.Models.DayModel({
					date: nextDate.format('DD.MM.YYYY'),
					dateFormatted: nextDate,
					dateCompact: moment(nextDate)
						.format('DD.MM'),
					work: false,
					inactive: true,
					dow: nextDate.format('d'),
					activeClass: 'past'
				}));
				end++;
				nextDate = moment(nextDate)
					.add(1, 'days');
			} while (end < dim);
		}
		var lastDow = parseInt(this.models[this.models.length - 1].get('dow'));
		if (lastDow <= 6) {
			var lastDay = this.models[this.models.length - 1];
			var lastDate = this.models[this.models.length - 1].get('dateFormatted'),
				nextDate = moment(lastDate)
				.add(1, 'days');
			do {
				this.push(new BookingApp.Models.DayModel({
					date: nextDate.format('DD.MM.YYYY'),
					dateFormatted: nextDate,
					dateCompact: moment(nextDate)
						.format('DD.MM'),
					work: false,
					inactive: true,
					dow: nextDate.format('d'),
					activeClass: 'past next-month'
				}));
				lastDow++;
				nextDate = moment(nextDate)
					.add(1, 'days');
			} while (lastDow <= 6);
		}
	},
	selectedDay: function (day) {
		var date = day.get('dateFormatted');
		this.orderProps.date = date;
	}
});
/*Коллекция дня (набор часов)*/
BookingApp.Collections.DayCollection = Backbone.Collection.extend({
	model: BookingApp.Models.HourModel,
	initialize: function () {
		this.on('change:selected', this.calculateDuration, this);
		if (typeof CLNDR_MODE !== 'undefined' && CLNDR_MODE === 'limited') {
			this.on('change:selected', this.controlLimit, this);
		}
	},
	/**Проверка непрерывности интервала бронирования при выделении часа.
	 * Если интервал прерывается - не даём выделять час.
	 * */
	checkContinuityOnSelect: function (curr) {
		var selected = this.where({
				'selected': true
			}), //выбраные на текущий момент часы
			selectedArr = this.pluck('selected'), //индекс коллекции по полю selected
			valueArr = this.pluck('value'), //индекс коллекции по полю value
			prevSelected = true,
			nextSelected = true,
			currVal = curr.get('value'),
			currIndex = valueArr.indexOf(currVal);
		if (selected.length > 0) {
			if (currIndex > 0) prevSelected = selectedArr[currIndex - 1];
			else prevSelected = selectedArr[1];
			if (currIndex < selectedArr.length) nextSelected = selectedArr[currIndex + 1];
		}
		return (prevSelected || nextSelected);
	},
	/**Вызывается при отмене выделения часа для проверки непрерывности интервала.
	 * Не даём прерваться выбранному интервалу*/
	controlContinuity: function (curr) {
		var selected = this.where({
				'selected': true
			}), //выбраные на текущий момент часы
			valueArr = [];
		selected.map(function (model, key) {
			valueArr[key] = model.get('value');
		});
		var index = valueArr.indexOf(curr.get('value'));
		if (index === 0 || index === valueArr.length - 1) curr.set('selected', false);
		else {
			KApp.Helpers.showNotify({
				type: 'warning',
				text: 'Интервал бронирования должен быть непрерывным'
			}, 2000, $('#order-alerts'));
		}
	},
	controlLimit: function () {
		var selected = this.where({
			'selected': true
		});
		var limit = 1;
		if (typeof CLNDR_LIMIT !== 'undefined') var limit = CLNDR_LIMIT;
		if (selected.length >= limit) {
			var unselected = this.where({
				selected: false
			}); //невыбранным часам проставляем свойство blocked: true;
			unselected.map(function (hour) {
				hour.set('blocked', true);
			}, this);
		} else {
			var blocked = this.where({
				blocked: true
			});
			blocked.map(function (hour) {
				hour.set('blocked', false);
			}, this);
		}
	},
	getSelectedHours: function () {
		var selected = this.where({
			'selected': true
		});
		var result = [];
		_.map(selected, function (h, v) {
			result.push(h.get('value'));
		});
		return result;
	},
	clearSelection: function () { //очистка выбранных полльзователем часов
		var selected = this.where({
			selected: true
		});
		if (selected.length) {
			_.map(selected, function (hour) {
				hour.set('selected', false);
			});
		}
	}
});
/*Коллекция ростеров*/
BookingApp.Collections.RoastersCollection = Backbone.Collection.extend({
	model: BookingApp.Models.RoasterModel,
	initSelected: function () {
		var selected = this.findWhere({
			'selected': true
		});
		if (selected) this.updateSelected(selected);
	},
	updateSelected: function (model) {
		var oldSelected = this.findWhere({
			'selected': true
		});
		if (oldSelected) oldSelected.set('selected', false);
		model.set('selected', true);
		this.trigger('updateSelected', model.attributes);
	}
});
/*Коллекция месяцов*/
BookingApp.Collections.MonthsCollection = Backbone.Collection.extend({
	model: BookingApp.Models.MonthModel,
	initialize: function () {
		this.on('changeMonth', this.changeMonth, this);
	},
	changeMonth: function (month) {
		var current = this.findWhere({
				active: true
			}),
			newActive = this.findWhere({
				month: month
			});
		current.set('active', false);
		newActive.set('active', true);
		this.trigger('activeChanged');
	}
});
/*Вид оформления брони (в сайдбаре)*/
BookingApp.Views.BookingCheckoutView = Backbone.View.extend({
	el: '#booking-checkout',
	initialize: function () {
		this.render(); //рендеринг основного каркаса
		this.renderRoaster(); //выбранный ростер
		this.renderHours(); //выбранные часы
		this.renderPayers(); //выбранный плательщик
		this.renderSummary(); //итоги
		this.renderSearch();
		this.model.on('change:roaster', this.renderRoaster, this); //смена ростера
		this.model.on('change:date', this.renderDate, this); //смена даты
		this.model.on('change:date', this.showHours, this); //смена часов
		this.model.on('change:currentStep', this.changeStep, this); //смена текущего шага
		this.model.on('orderSuccess', this.showOrderResults, this);
	},
	render: function () {
		var tplName = 'tpl-booking-checkout';
		if (typeof ORDER_ID !== 'undefined') tplName = 'tpl-booking-checkout-in-order';
		var tpl = KApp.Helpers.template(tplName);
		this.el.innerHTML = tpl(this.model.attributes);
	},
	renderRoaster: function () {
		var roasterWrapper = document.getElementById('booking-roaster-name');
		var roaster = this.model.get('roaster');
		if (roaster !== '' && roasterWrapper) {
			var tpl = _.template('<b>Ростер:</b> <%=title%>');
			roasterWrapper.innerHTML = tpl(this.model.get('roaster'));
		}
	},
	renderDate: function () {
		var date = this.model.get('date');
		var dateWrapper = this.el.querySelector('#booking-roaster-date');
		if (typeof date !== 'undefined' && date !== '') {
			var tpl = _.template('<b>Дата:</b> <%=date%>');
			if (dateWrapper) dateWrapper.innerHTML = tpl(this.model.attributes);
		}
	},
	renderHours: function () {
		var hoursView = new BookingApp.Views.DayView({
			model: this.model
		});
	},
	/*Рендеринг поиска по организациям*/
	renderSearch: function () {
		var searchModel = this.model.get('orgSearch');
		if (searchModel) {
			var searchView = new OrgSearch.Views.SearchFieldView({
				model: searchModel
			});
			this.model.on('change:interval', this.showSearch, this);
		}
	},
	showSearch: function () {
		var searchWrapper = this.el.querySelector('#org-search-wrapper')
		if (searchWrapper) searchWrapper.classList.remove('d-none');
	},
	showHours: function () {
		var hoursWrapper = this.el.querySelector('#booking-hours-wrapper');
		if (this.model.get('date')) {
			hoursWrapper.classList.remove('d-none');
		} else {
			hoursWrapper.classList.add('d-none');
		}
	},
	renderSummary: function () {
		var summaryView = new BookingApp.Views.BookingSummaryView({
			model: this.model
		});
	},
	renderPayers: function () {
		var payersList = this.model.get('payersList');
		if (payersList) {
			var payersView = new KApp.Views.PayersList({
				collection: payersList
			});
			this.model.on('change:interval', this.showPayers, this);
		}
	},
	showPayers: function () {
		var payersWrapper = document.getElementById('payers-section');
		if (payersWrapper) {
			payersWrapper.classList.remove('d-none');
		}
	},
	changeStep: function (model, step) {
		KApp.Helpers.changeStep(model, step);
	},
	/*Показывает итоги заказа (успех-неуспех)
	 * */
	showOrderResults: function (data) {
		var info = new KApp.Models.InfoMessageModel(data);
		var view = new KApp.Views.OrderResultsView({
			model: info
		});
	}
});
/*Вид дня в календаре*/
BookingApp.Views.CalendarDayView = Backbone.View.extend({
	tagName: 'td',
	className: 'day',
	events: {
		"click .day-contents": "selectDay"
	},
	initialize: function () {},
	render: function () {
		var date = this.model.get('date'),
			clndr_theme = "basic",
			tpl = _.template('<div class="day-contents"><%=parseInt(date)%></div>');
		if (typeof CLNDR_THEME !== "undefined") {
			clndr_theme = CLNDR_THEME;
			var dateArr = date.split('.');
			date = dateArr[0]; // + '.' + dateArr[1];
		}
		this.el.innerHTML = tpl({
			date: date
		});
		var activeClasses = this.model.get('activeClass')
			.split(' ');
		_.map(activeClasses, function (className) {
			this.el.classList.add(className);
		}, this);
		return this;
	},
	selectDay: function () {
		if (this.model.get('work') === true) {
			var days = this.el.parentNode.parentNode,
				oldSelected = days.querySelector('.selected');
			if (oldSelected) oldSelected.classList.remove('selected');
			this.el.classList.add('selected');
			this.model.collection.trigger('selected', this.model);
			this.trigger('updated');
		}
	}
});
/*Вид календаря*/
BookingApp.Views.CalendarView = Backbone.View.extend({
	el: '#clndr tbody',
	row: '',
	initialize: function () {
		this.collection.on('reset', this.render, this);
		this.render();
	},
	render: function () {
		var clndr_theme = '';
		if (typeof clndr_theme !== 'undefined') clndr_theme = 'mode--' + CLNDR_THEME;
		this.el.parentNode.classList.add(clndr_theme);
		this.collection.prepareCalendar();
		var dayCounter = 0;
		$(this.el)
			.html('');
		this.collection.each(function (model) {
			if (dayCounter === 0) this.el.appendChild(document.createElement('tr'));
			this.el.querySelector('tr:last-child')
				.appendChild(this.addOne(model));
			dayCounter++;
			if (dayCounter > 6) dayCounter = 0;
		}, this);
	},
	addOne: function (day) {
		var dayView = new BookingApp.Views.CalendarDayView({
			model: day
		});
		return dayView.render()
			.el;
	},
	resetSelection: function () {
		var $selected = $(this.el)
			.find('.selected');
		if ($selected) $selected.removeClass('selected');
	},
	/*Скрытие блока с календарём.
	Вызывается после успешной брони ростера ВНУТРИ ЗАКАЗА
	*/
	hideWrapper: function () {
		var $wrapper = $(this.el)
			.parents('#calendar-wrapper');
		if ($wrapper) {
			$wrapper.hide(0);
		}
	}
});
/*Вид дня (список часов)*/
BookingApp.Views.DayView = Backbone.View.extend({
	el: '#booking-roaster-time',
	initialize: function () {
		this.render();
		var hours = this.model.get('hours');
		hours.on('reset', this.render, this);
		//this.model.on('reset:hours', this.render, this);
	},
	render: function () {
		if (typeof CLNDR_THEME !== "undefined") this.el.classList.add('mode--' + CLNDR_THEME);
		this.el.innerHTML = '';
		var hours = this.model.get('hours');
		if (hours) {
			hours.each(this.addOne, this);
			if (hours.length) this.el.classList.remove('d-none');
			else this.el.classList.add('d-none');
			return this;
		}
	},
	addOne: function (item, index) {
		if (index === 0 || index === 2) this.renderSeparator(index);
		var hour = new BookingApp.Views.HourView({
			model: item
		});
		this.$el.append(hour.render()
			.el);
	},
	renderSeparator: function (index) {
		var separators = {
			0: 'Утро',
			2: 'День'
		};
		var separator = document.createElement('li');
		separator.classList.add('day-separator');
		separator.innerHTML = separators[index];
		this.el.appendChild(separator);
	},
	updateView: function (selectedDay) {
		var hours = selectedDay.get('hours');
		this.collection.reset(hours);
	},
	hideHours: function () {
		var $parent = $(this.wrapper)
			.parents('.booking-hours-wrapper');
		if ($parent) $parent.removeClass('in');
	}
});
/*Вид часа*/
BookingApp.Views.HourView = Backbone.View.extend({
	tagName: 'li',
	className: 'hour-item',
	events: {
		"click .free-hour": "toggleHour" //выбор часа
	},
	initialize: function () {
		this.model.on('change', this.render, this);
	},
	render: function () {
		var hourTpl = _.template('<button class="hour-item-btn <%if(selected == true){%>active<%}%> <%if(reserved == false){%>free-hour<%}%>" <%if(reserved == true || blocked == true){%>disabled<%}%>><%=value%>:00</button>');
		this.el.innerHTML = hourTpl(this.model.attributes);
		return this;
	},
	toggleHour: function () { // выбор/отмена часа
		this.model.toggleSelect();
	}
});
BookingApp.Views.BookingSummaryView = Backbone.View.extend({
	el: '#booking-roaster-summary',
	events: {
		'click .btn-order': 'sendOrder'
	},
	initialize: function () {
		this.render();
		this.model.on('change', this.render, this);
	},
	render: function () {
		var tpl = KApp.Helpers.template('tpl-booking-summary');
		this.el.innerHTML = tpl(this.model.attributes);
	},
	sendOrder: function () {
		this.model.sendOrder();
	}
});
BookingApp.Views.BookingOrderView = Backbone.View.extend({
	el: '#order',
	initialize: function () {
		if (typeof CLNDR_MODE !== 'undefined' && CLNDR_MODE === 'limited') {
			this.model.on('change', this.checkLimits, this);
		}
	},
	checkLimits: function () {
		var inLimit = this.model.checkLimits();
		var btn = this.el.querySelector('.btn-booking');
		btn.disabled = !inLimit;
	}
});
BookingApp.Views.RoasterView = Backbone.View.extend({
	tagName: 'li',
	className: 'roaster-item',
	events: {
		'click .roaster-item__inner:not(.disabled)': 'updateRoastersList'
	},
	initialize: function () {
		this.render();
		this.model.on('change', this.render, this);
	},
	render: function () {
		var tpl = KApp.Helpers.template('tpl-roaster-card');
		this.$el.html(tpl(this.model.attributes));
	},
	updateRoastersList: function () {
		this.model.collection.updateSelected(this.model);
	}
});
BookingApp.Views.RoastersListView = Backbone.View.extend({
	tagName: 'ul',
	className: 'roasters-list',
	initialize: function () {
		this.render();
	},
	render: function () {
		this.collection.each(this.addOne, this);
	},
	addOne: function (item) {
		var item = new BookingApp.Views.RoasterView({
			model: item
		});
		this.$el.append(item.$el);
	}
});
/*Переключатель месяца в календаре*/
BookingApp.Views.ClndrControlView = Backbone.View.extend({
	tagName: 'li',
	className: 'nav-item',
	events: {
		'click .month-btn': 'changeMonth'
	},
	initialize: function () {
		this.render();
		this.model.collection.on('activeChanged', this.render, this);
	},
	render: function () {
		var tpl = _.template('<span class="nav-link month-btn <%if(active){%>active<%}%>"><%=monthStr%></span>');
		this.$el.html(tpl(this.model.attributes));
		return this;
	},
	changeMonth: function () {
		this.model.collection.trigger('changeMonth', this.model.get('month'));
	}
});
/*Список переключателей*/
BookingApp.Views.ClndControlsView = Backbone.View.extend({
	tagName: 'ul',
	className: 'nav nav-pseudo-tabs',
	initialize: function () {
		this.render();
	},
	render: function () {
		this.collection.each(this.addOne, this);
	},
	addOne: function (month) {
		var monthItem = new BookingApp.Views.ClndrControlView({
			model: month
		});
		this.$el.append(monthItem.$el);
	}
});
$(function () {
	if (typeof calendar !== 'undefined' && typeof roasters !== 'undefined' && typeof payers !== 'undefined') {
		var dates = BookingApp.Helpers.prepareCalendar(calendar); //коллекция дат
		var monthsArr = BookingApp.Helpers.prepareClndrByMonths(dates); // месяцы (сырые)
		var months = new BookingApp.Collections.MonthsCollection(monthsArr); //месяцы (подготовленные)
		var calendarCollection = new BookingApp.Collections.CalendarCollection(months.at(0)
			.get('days')); //список доступных дней для бронирования
		var bookingPayers = new KApp.Collections.PayersCollection();
		if (typeof payers !== "undefined") bookingPayers.reset(payers);
		var bookingHours = new BookingApp.Collections.DayCollection([]); //часы (пока пустые)
		var roastersList = new BookingApp.Collections.RoastersCollection(roasters); //список ростеров
		var initalRentCheckoutData = {
			roastersList: roastersList,
			payersList: bookingPayers,
			hours: bookingHours
		}
		if (typeof ORG_SEARCH_URL !== "undefined") {
			var searchModel = new OrgSearch.Models.SearchModel(); //поиск по плательщикам
			initalRentCheckoutData.orgSearch = searchModel;
		}
		var checkoutModel = new BookingApp.Models.BookingModel(initalRentCheckoutData); //данные для бронирования
		checkoutModel.listenTo(calendarCollection, 'selected', checkoutModel.setBookingDate); //обновляем выбранную дату
		checkoutModel.listenTo(months, 'changeMonth', checkoutModel.clearOrder); //при смене месяца очищаем заказ
		calendarCollection.listenTo(months, 'changeMonth', function (month) {
			var newMonth = months.findWhere({
				month: month
			});
			var newDays = newMonth.get('days');
			calendarCollection.reset(newDays);
		});
		if (typeof ORDER_ID !== 'undefined') checkoutModel.set('orderId', ORDER_ID, {
			silent: true
		}); //добавляем id заказа, если нужно
		if (typeof roastQuantity !== "undefined") checkoutModel.set('roastQuantity', roastQuantity, {
			silent: true
		}); //добавляем количество кофе для обжарки (если нужно)
		var checkoutView = new BookingApp.Views.BookingCheckoutView({
			model: checkoutModel
		});
		//переключатели месяцев
		var monthsControls = new BookingApp.Views.ClndControlsView({
			collection: months
		});
		$('#clndr-controls')
			.html(monthsControls.$el); //переключатели месяцев
		var calendarView = new BookingApp.Views.CalendarView({
			el: document.querySelector('#clndr tbody'),
			collection: calendarCollection
		}); //отображение календаря
		if (typeof CLNDR_MODE !== "undefined" && CLNDR_MODE === 'default') { //если режим обычный (не из заказа), то рисуем список ростеров.
			var roastersView = new BookingApp.Views.RoastersListView({
				collection: roastersList
			});
			$('#roasters-list')
				.html(roastersView.$el);
		}
		calendarView.listenTo(checkoutModel, 'successBooking', calendarView.resetSelection);
		if (typeof ORDER_ID !== 'undefined') {
			calendarView.listenTo(checkoutModel, 'successBooking', calendarView.hideWrapper);
		}
	}
});
/*Повторение заказа*/
$(function () {
	var repeatOrderBtn = document.querySelector('.btn-repeat-order');
	var repeatConfirmModel = new KApp.Models.ConfirmModel({
		title: 'Вы действительно хотите повторить заказ?',
		sizeClass: 'wf-popup-medium',
		oktext: 'Да, повторите',
		notext: 'Нет, закрыть это окно'
	});
	if (repeatOrderBtn) {
		repeatOrderBtn.addEventListener('click', function (e) {
			var orderid = e.target.dataset.order;
			repeatConfirmModel.confirmCallback = function () {
				repeatOrder(orderid);
			};
			var repeatConfirmView = new KApp.Views.ConfirmModal({
				model: repeatConfirmModel
			});
			e.preventDefault();
		});
	}
});

function repeatOrder(orderid) {
	var sessid = BX.bitrix_sessid();
	if (orderid !== undefined) {
		$.ajax({
			url: '/ajax/clone_order.php',
			method: 'post',
			data: {
				sessid: sessid,
				id: orderid
			},
			success: function (res) {
				var popupData = {
					status: res.status,
					title: "Ошибка",
					message: res.message
				};
				if (res.success) {
					popupData.status = "success";
					popupData.title = "Ваш Заказ успешно продублирован.";
					popupData.message = res.message;
				}
				var info = new KApp.Models.InfoMessageModel(popupData),
					infoModal = new KApp.Views.Modal({
						model: info
					});
				/*Редирект на бронирование ростера, если в заказе был кофе с обжаркой*/
				if (res.roastRedirect) setTimeout(function () {
					location.href = res.roastRedirectURL;
				}, 5000);
			},
		});
	}
}
/**
 * reviews.js starts
 * Created by mac on 2019-01-28.
 */
$(function () {
	var sessid = BX.bitrix_sessid();
	KApp.Models.ReviewModel = Backbone.Model.extend({
		defaults: {
			sessid: sessid,
			id: "",
			name: "",
			comment: "",
		},
		sendReview: function () {
			var data = this.attributes;
			var model = this;
			var result = {};
			$.ajax({
				url: REVIEWS_URL,
				method: 'post',
				data: data,
				success: function (res) {
					if (res.success) {
						model.trigger('successSend');
					}
				},
				error: function (err) {
					console.log(err);
				}
			});
		}
	});
	KApp.Views.ReviewFormView = Backbone.View.extend({
		tagName: "div",
		className: "review-form",
		comment: ".review-text",
		error: {
			id: "comment-error",
			message: "Слишком короткий комментарий"
		},
		events: {
			"input .review-text": "updateReview",
			"click .btn-send-review": "sendReview"
		},
		initialize: function () {
			this.render();
			this.model.on('successSend', this.drawResults, this); //добавляем комментарий на страницу
		},
		render: function () {
			var tpl = KApp.Helpers.template('tpl-add-review');
			this.el.innerHTML = tpl(this.model.attributes);
			var commentTextarea = this.el.querySelector('.plugin-autosize');
			autosize(commentTextarea); //
		},
		updateReview: function (e) {
			this.model.set('comment', e.target.value);
			return this;
		},
		checkReview: function () {
			var comment = this.model.get('comment');
			if (comment !== '' && comment.length > 20) {
				this.hideError();
				return true;
			} else {
				this.showError();
				this.listenToOnce(this.model, 'change', this.checkReview);
				return false;
			}
		},
		hideError: function () {
			var errorid = this.error.id;
			var error = document.getElementById(errorid);
			if (error !== null) $(error)
				.detach();
			return this;
		},
		showError: function () {
			var errorid = this.error.id;
			var sameError = document.getElementById(errorid);
			if (sameError === null) {
				var error = document.createElement('span');
				error.innerHTML = this.error.message;
				error.classList.add('error');
				error.id = this.error.id;
				var $review = this.$el.find('.review-text');
				$review.parent()
					.append(error);
			}
			return this;
		},
		sendReview: function () {
			var checkResult = this.checkReview();
			if (checkResult) {
				this.model.sendReview();
			}
		},
		/*Дорисовываем комментарий*/
		drawResults: function () {
			var tpl = KApp.Helpers.template('tpl-comment-bubble');
			this.el.innerHTML = tpl(this.model.attributes);
			this.updateButton();
		},
		/*Обновляем кнопку после сохранения комментария*/
		updateButton: function () {
			var attrs = this.model.attributes;
			var buttons = document.querySelectorAll("[data-id=btn-" + attrs.id + " ]")
			var updateBtn = function (btn) {
				var caption = 'Сохранить';
				if (attrs.comment.length) caption = 'Редактировать';
				var info = attrs.id + '|' + attrs.comment;
				btn.setAttribute('data-info', info);
				btn.innerHTML = caption;
			}
			for (var i = 0; i < buttons.length; i++) {
				updateBtn(buttons[i]);
			}
		}
	});
	$(document)
		.on('click', '.add-probe-review', function (e) {
			e.preventDefault();
			var data = e.target.dataset.info.split('|');
			var reviewData = {
				id: data[0]
			};
			var btn = this;
			if (typeof data[1] !== "undefined") reviewData.comment = data[1];
			var $wrapper = $(this)
				.parents('.order-card')
				.find('.comment-wrapper');
			if (typeof REVIEWS_URL !== 'undefined' && $wrapper.length) {
				var reviewModel = new KApp.Models.ReviewModel(reviewData);
				var reviewPopup = new KApp.Views.ReviewFormView({
					model: reviewModel,
					el: $wrapper[0],
					button: btn
				});
			}
		});
});
/* reviews.js ends */
//# sourceMappingURL=maps/personal_app.js.map
